<style scoped>
  .table-expend:hover{
    background: #e9e9e9;
    cursor: pointer;
  }
  .table-disabled{
    background: #d2cece;
  }
  .table-expend:active,.table-expend-combo td.combo:active{
      background: #e7e5e5;
  }
</style>
<template>
  <div>
    <vs-row
      :class="showSkuTable ? 'flex flex-wrap gap-2' : ''"
      class="justify-between"
    >
      <vs-col :vs-w="showSkuTable ? '5' : '12'">
        <p class="text-xl text-bold">List Item Units</p>
        <hr />
        <div class="flex">
          <vs-button
            color="primary"
            type="filled"
            size="small"
            class="my-4"
            icon="search"
            v-show="showBtnSearch"
            @click="toggleShowSkuTable"
            >Search</vs-button
          >
          <!-- <vs-button
            color="danger"
            type="filled"
            size="small"
            class="my-4"
            icon="restore"
            v-show="!showBtnSearch"
            @click="clickRestore"
          /> -->
        </div>

        <!-- table selected line item -->
        <table class="table table-bordered" style="width:100%">
          <thead>
            <th> # </th>
            <th> SKU Code </th>
            <th> SKU Name </th>
            <th v-if="form.so_types == 'with_so_reference'">
              Qty Invoice
            </th>
            <th> HU </th>
            <th v-if="form.so_types == 'with_so_reference'"> 
              Qty General Inv. 
            </th>
            <th v-if="form.so_types == 'with_so_reference' && form.isDetail == 0"> 
            <!-- <th v-if="form.so_types == 'with_so_reference'">  -->
              Qty General Remaining. 
            </th>
            <th> Qty Return </th>
            <th v-if="form.so_types == 'with_so_reference'"> 
              Qty General Return 
            </th>
            <th>Reason</th>
            <th>Attachments </th>
            <th v-show="form.so_types == 'without_so_reference'" style="width: 100px;">PPN Type </th>
            <th v-show="form.so_types == 'without_so_reference'">Price</th>
            <th v-show="form.so_types != 'without_so_reference'">Price<br>(Include Disc) </th>
            <th v-if="form.so_types == 'without_so_reference'">Adj. Price</th>
            <!-- <vs-th>Sub Total</vs-th> -->
            <th>Reg. Discount</th>
            <th>Tax</th>
            <th>Grand Total </th>
          </thead>
          <tbody>
            <template v-for="(tr, indextr) in selectedItemUnits" >
              <tr :key="indextr">
                <td :rowspan="tr.is_expand? 2 : null" :class="(form.so_types == 'with_so_reference' && !tr.info.allow_return ? 'table-disabled' : '')">
                  <vs-button
                    v-show="showDeleteOnly(tr)"
                    color="danger"
                    type="filled"
                    size="small"
                    icon="delete"
                    @click="handleDelete(tr)"
                  />
                </td>
                <td :rowspan="tr.is_expand? 2 : null" :class="(form.so_types == 'with_so_reference' && !tr.info.allow_return ? 'table-disabled' : '')">
                  <span v-if="tr.parent && !tr.isFreeGood">{{ tr.sku_code }}</span>
                  <strong v-if="tr.parent && tr.isFreeGood" class="text-success">
                    {{ tr.sku_code }}
                  </strong>
                </td>
                <td :rowspan="tr.is_expand? 2 : null" :class="(form.so_types == 'with_so_reference' && !tr.info.allow_return ? 'table-disabled' : '')">
                  <span v-if="tr.parent && !tr.isFreeGood">{{ tr.item_name }}</span>
                  <strong v-if="tr.parent && tr.isFreeGood" class="text-success">
                    {{ tr.item_name }}
                  </strong>
                </td>
                <td v-if="form.so_types == 'with_so_reference'" :rowspan="tr.is_expand? 2 : null" :class="(!tr.info.allow_return ? 'table-disabled' : '')">
                  {{ tr.qty_invoice }}
                </td>
                <td :rowspan="tr.is_expand? 2 : null" :class="(form.so_types == 'with_so_reference' && !tr.info.allow_return ? 'table-disabled' : '')">
                  {{ tr.unit_name }}
                </td>
                <td v-if="form.so_types == 'with_so_reference'" :rowspan="tr.is_expand? 2 : null" :class="(!tr.info.allow_return ? 'table-disabled' : '')">
                  <!-- Qty general Invoice -->
                  {{ tr.qty_general_invoice + " " + tr.lilUom }}
                </td>
                <!-- <td v-if="form.so_types == 'with_so_reference' && tr.parent" :rowspan="tr.parent? ( tr.is_expand? tr.units.length+tr.rowSpanPlus : tr.units.length+tr.rowSpanPlus ) : 1" :class="(!tr.info.allow_return ? 'table-disabled' : '')"> -->
                <td v-if="form.so_types == 'with_so_reference' && tr.parent && form.isDetail != 1" :rowspan="tr.parent? ( tr.is_expand? tr.units.length+tr.rowSpanPlus : tr.units.length+tr.rowSpanPlus ) : 1" :class="(!tr.info.allow_return ? 'table-disabled' : '')">
                  <!-- Qty general Invoice - Remaining -->
                  <!-- {{ (tr.qty_general_invoice - tr.qty_general_used) + " " + tr.lilUom }} -->
                  {{ (tr.total_qty_general_invoice - tr.total_qty_general_used) + " " + tr.lilUom }}
                </td>
                <td :rowspan="tr.is_expand? 2 : null" :class="(form.so_types == 'with_so_reference' && !tr.info.allow_return ? 'table-disabled' : '')">
                  <NumberInput
                    v-model="tr.quantity"
                    :min="0"
                    :disabled="disabledInput || (form.so_types == 'with_so_reference' && return_type_str == '1') || (form.so_types == 'with_so_reference' && tr.qty_invoice == 0 && return_type_str == '1') || !tr.info.allow_return"
                  />
                </td>
                <td v-if="form.so_types == 'with_so_reference' && tr.parent" :rowspan="tr.parent? ( tr.is_expand? tr.units.length+tr.rowSpanPlus : tr.units.length+tr.rowSpanPlus ) : 1" :class="(!tr.info.allow_return ? 'table-disabled' : '')">
                  <!-- Qty general Return -->
                  {{ tr.total_qty_general_return + " " + tr.lilUom }}
                </td>
                <td :rowspan="tr.is_expand? 2 : null" :class="(form.so_types == 'with_so_reference' && !tr.info.allow_return ? 'table-disabled' : '')">
                  <!-- MIX2-5452 ditampilkan reason untuk semua HU -->
                  <!-- v-show="showDelete(tr) || (tr.parent)" -->
                  <multiselect
                    v-show="true"
                    :disabled="disabledInput || (form.so_types == 'with_so_reference' && tr.qty_invoice == 0 && return_type_str == '1') || !tr.info.allow_return || (form.so_types == 'with_so_reference' && tr.quantity == 0 && return_type_str == '0')"
                    v-model="tr.reason"
                    :options="optionsReason"
                    :max-height="125"
                    :allow-empty="true"
                    :select-label="''"
                    deselect-label=""
                    :searchable="true"
                    :custom-label="customLabelReason"
                  >
                    <span slot="noResult">Oops! No data found</span>
                  </multiselect>
                </td>
                <td :rowspan="tr.is_expand? 2 : null" :class="(form.so_types == 'with_so_reference' && !tr.info.allow_return ? 'table-disabled' : '')">
                  <!-- MIX2-5452 ditampilkan attachment untuk semua HU -->
                  <!-- v-show="(showDelete(tr) || (tr.parent)) && !disabledInput" -->
                  <InputFile
                    v-show="!disabledInput"
                    :isDisabled="disabledInput || (form.so_types == 'with_so_reference' && tr.qty_invoice == 0 && return_type_str == '1') || !tr.info.allow_return || (form.so_types == 'with_so_reference' && tr.quantity == 0 && return_type_str == '0')"
                    :acceptedTypes="acceptedTypes"
                    @data="setAttachment($event, tr.sku_code, tr.unit_name)"
                    setPathUpload="sales-return-v2"
                    :isWithAPI="true"
                  />
                  <!-- list -->
                  <!-- <ul class="mt-2" v-if="tr.parent && tr.attachments!=null"> -->
                  <ul class="mt-2" v-if="tr.attachments!=null">
                    <li
                      v-for="(attachment, index) in tr.attachments"
                      :key="index"
                      class="mb-2"
                    >
                      <div class="flex gap-2">
                        <a
                          :href="attachment"
                          target="_blank"
                          class="text-blue-500"
                          >File {{ index + 1 }}</a
                        >
                        <!-- delete btn -->
                        <vs-button
                          color="danger"
                          type="filled"
                          size="small"
                          icon="delete"
                          v-if="!disabledInput"
                          @click="handleDeleteAttachment(tr, index)"
                        />
                      </div>
                    </li>
                  </ul>
                  <!-- <span v-if="tr.parent && tr.attachments==null">No Attachment.</span> -->
                  <!-- MIX2-5452 ditampilkan attachment untuk semua HU -->
                  <span v-if="tr.attachments==null">No Attachment.</span>
                </td>
                <td v-show="form.so_types == 'without_so_reference'" :rowspan="tr.is_expand? 2 : null">
                  <!-- <span>{{ (tr.tax[0].Name != undefined && tr.tax[0].Name != null) ? tr.tax[0].Name : "-" }}</span> -->
                  <!-- <span>{{ (tr.taxName != undefined && tr.taxName != null) ? tr.taxName : "-" }}</span><br> -->
                  <!-- <SelectTax v-if="(showDelete(tr) || (tr.parent)) && form.so_types == 'without_so_reference'" @data="setGlobalSelectTax" @trigger="setSelectTax(tr, indextr)" ref="selectTax" /> -->
                  <!-- <br> -->
                  <multiselect
                    v-show="showDelete(tr) || (tr.parent)"
                    :disabled="disabledInput"
                    v-model="selectedItemUnits[indextr].tax"
                    :options="optionsTax"
                    :max-height="125"
                    :allow-empty="true"
                    :select-label="''"
                    deselect-label=""
                    :searchable="true"
                    :custom-label="customLabelTaxes"
                    @input="onSelectedTaxes(indextr)"
                  >
                    <span slot="noResult">Oops! No data found</span>
                  </multiselect>
                </td>
                <td v-on:click="expandDetail(tr,indextr)" :class="form.so_types == 'without_so_reference' ? '' : (!tr.info.allow_return ? 'table-disabled' : 'table-expend')">
                  <span v-on:click="expandDetail(tr,indextr)">{{ formatCurrencyIDR( form.so_types == 'without_so_reference' ? tr.price : tr.sr_price) }}</span>
                </td>
                <!-- <td>
                  <span>{{ formatCurrencyIDR(tr.subtotal) }}</span>
                </td> -->
                <td v-show="form.so_types == 'without_so_reference'">
                  <NumberInput
                    v-model="tr.adj_price"
                    :min="0"
                    :version="'v2'"
                    :disabled="disabledInput"
                  />
                </td>
                <td v-on:click="expandDetail(tr,indextr)" :class="form.so_types == 'without_so_reference' ? '' : (!tr.info.allow_return ? 'table-disabled' : 'table-expend')">
                  {{ formatCurrencyIDR(tr.total_discount) }}
                </td>
                <td v-on:click="expandDetail(tr,indextr)" :class="form.so_types == 'without_so_reference' ? '' : (!tr.info.allow_return ? 'table-disabled' : 'table-expend')">
                  {{ formatCurrencyIDR(tr.taxAmount) }}
                </td>
                
                <!-- <th>Grand Total </th> -->
                <td v-if="form.so_types == 'without_so_reference'" v-on:click="expandDetail(tr,indextr)" :class="form.so_types == 'without_so_reference' ? '' : (!tr.info.allow_return ? 'table-disabled' : 'table-expend')">
                  <!-- {{ formatCurrencyIDR( parseFloat(tr.price) * parseFloat(tr.quantity) + parseFloat(tr.taxAmount) - parseFloat(tr.discount) ) }} -->
                  {{ tr.quantity > 0 ? formatCurrencyIDR( parseFloat(tr.adj_price) * parseFloat(tr.quantity) + parseFloat(tr.taxAmount) - parseFloat(tr.discount) ) : formatCurrencyIDR( parseFloat("0") ) }}
                </td>
                <td v-else v-on:click="expandDetail(tr,indextr)" :class="form.so_types == 'without_so_reference' ? '' : (!tr.info.allow_return ? 'table-disabled' : 'table-expend')">
                  <!-- {{ tr.quantity > 0 ? formatCurrencyIDR( parseFloat(tr.sr_price) * parseFloat(tr.quantity) + parseFloat(tr.taxAmount) - parseFloat(tr.discount) ) : formatCurrencyIDR( parseFloat("0") ) }} -->
                  {{ tr.quantity > 0 && tr.info.allow_return ? formatCurrencyIDR( parseFloat(tr.sr_price) * parseFloat(tr.quantity) + parseFloat(tr.taxAmount) ) : formatCurrencyIDR( parseFloat("0") ) }}
                </td>
              </tr>
              <!--  -->
              <!-- Coba detail pricing -->
              <!-- 
              MIX2-2500206
              Informasi pricing dimunculkan keseluruhan dari discount, discount freegood, rounding & grossup seperti 
              table dan dapat diprorate berdasarkan referensi pricing sales invoice seperti contoh excell
              -->
              <!-- <tr :key="'expand-head-'+index+'-'+i" v-if="tr.is_expand ? true : false"> -->
              <tr :key="'expand-head-'+indextr" v-if="tr.is_expand" style="width:75%">
              <!-- <tr :key="'expand-head-'+indextr"> -->
                <td colspan="4">
                  <tr>
                    <th>Discount</th>
                    <th>Discount Freegood</th>
                    <th>Rounding</th>
                    <th>Gross Up</th>
                  </tr>
                  <!-- expand-body -->
                  <tr >
                    <td>{{ formatCurrencyIDR(tr.info.discount) }}</td>
                    <td>{{ formatCurrencyIDR(tr.info.total_disc_fg) }}</td>
                    <td>{{ return_type_str == '1' ? formatCurrencyIDR(tr.info.rounding) : 0 }}</td>
                    <td>{{ return_type_str == '1' ? formatCurrencyIDR(tr.info.gross_up) : 0 }}</td>
                  </tr>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
          
        <!-- Info cannot return item -->
        <!-- <vs-row class="flex my-2" v-if="selectedItemUnits.length <= 0 && selectedItemUnitsInv.length > 0 && form.so_types != 'without_so_reference'">
          <vs-col vs-w="8" vs-offset="2">
            <div class="my-2 text-center">
              <h3 class="font-bold">
                Seluruh Item Dalam Invoice Mendapat Promo Berketentuan Tidak Dapat di Retur.<br>
                Tidak Ada Item yang Dapat di Retur.
              </h3>
            </div>
          </vs-col>
        </vs-row> -->
        
        <!-- return summary -->
        <vs-row class="flex my-2">
          <vs-col vs-w="4" vs-offset="8">
            <p class="text-xl">Return Summary</p>
            <hr />

            <div class="my-2 text-right">
              <label>Total List Price</label>
              <br />
              <h4 class="font-bold">
                <!-- {{ formatCurrencyIDR( parseFloat(form.summary_data.total_list_price) ) }} -->
                {{ formatCurrencyIDR( parseFloat(this.total_line.list_price) ) }}
              </h4>
            </div>

            <div class="my-2 text-right">
              <label>Total Adj. Price</label>
              <br />
              <h4 class="font-bold">
                <!-- {{ formatCurrencyIDR( parseFloat(form.summary_data.total_adj_price) ) }} -->
                {{ formatCurrencyIDR( parseFloat(this.total_line.adj_price) ) }}
              </h4>
            </div>
            <!-- <div class="my-2">
              <label>Total Net</label>
              <br />
              <h4 class="font-bold">
                {{ formatCurrencyIDR(parseFloat(form.summary_data.total_net)) }}
              </h4>
            </div> -->
            <div class="my-2 text-right">
              <label>Total Tax</label>
              <br />
              <h4 class="font-bold">
                {{ formatCurrencyIDR( parseFloat(this.total_line.tax) ) }}
              </h4>
            </div>

            <!--  -->

            <div v-if="form.so_types == 'with_so_reference'" class="my-2 text-right">
              <label>Total Discount</label>
              <br />
              <h4 class="font-bold">
                {{ formatCurrencyIDR( parseFloat(this.total_line.discount) ) }}
              </h4>
            </div>

            <!--  -->
            <div class="my-2 text-right">
              <label>Total Sales Return</label>
              <br />
              <h4 class="font-bold">
                <!-- {{ form.so_types == 'without_so_reference' ?
                  formatCurrencyIDR( parseFloat(form.summary_data.total_adj_price + form.summary_data.total_tax - form.summary_data.total_discount) ) 
                  :
                  formatCurrencyIDR( parseFloat(form.summary_data.total_list_price + form.summary_data.total_tax - form.summary_data.total_discount) )
                }} -->
                {{ formatCurrencyIDR( parseFloat(this.total_line.sales_return) ) }}
              </h4>
            </div>
            <!-- <div class="my-2">
              <label>Total Charges</label>
              <br />
              <h4 class="font-bold">
                {{
                  formatCurrencyIDR(parseFloat(form.summary_data.total_charges))
                }}
              </h4>
            </div>
            <div class="my-2">
              <label>Total Return</label>
              <br />
              <h4 class="font-bold">
                {{
                  formatCurrencyIDR(parseFloat(form.summary_data.total_return))
                }}
              </h4>
            </div> -->
          </vs-col>
        </vs-row>
      </vs-col>

      <!-- table choose item units -->
      <transition name="detail-fade">
        <vs-col v-if="showSkuTable" vs-w="6">
          <vs-col
            style="padding-bottom: 8px"
            vs-offset="8"
            vs-type="flex"
            vs-justify="rigth"
            vs-align="rigth"
            vs-w="4"
          >
            <vs-button
              class="ml-auto"
              size="small"
              v-on:click="handleClose"
              color="grey"
              icon-pack="feather"
              icon="icon-x-square"
              >Close</vs-button
            >
          </vs-col>
          <!-- <TableItemUnit
            @data="setItemUnit"
            ref="tableItemUnit"
            :itemUnitIDs="form.customer_invoice_data.item_unit_ids"
          /> -->
          <TableItem
            @data="setItem"
            ref="tableItem"
            :itemUnitIDs="form.customer_invoice_data.item_unit_ids"
          />
        </vs-col>
      </transition>
    </vs-row>
  </div>
</template>

<script>
import TableItemUnit from "@/components/master/TableItemUnit.vue";
import { formatCurrencyIDR } from "@/helpers/common.js";
import InputFile from "@/components/master/InputFile.vue";
import { RepositoryFactory } from "@/repositories/repositoryFactory";
import SelectMasterReasonV2 from "@/components/master/SelectMasterReasonV2.vue";
import TableItem from "@/components/master/TableItem.vue";
import VueNumericInput from "vue-numeric-input";
import NumberInput from "@/components/master/NumberInput.vue";
import SelectTax from "@/components/master/SelectTax.vue";

const SalesReturnV2Repo = RepositoryFactory.get("salesReturnV2");
const masterRepository = RepositoryFactory.get("master");

export default {
  components: {
    TableItemUnit,
    InputFile,
    SelectMasterReasonV2,
    VueNumericInput,
    TableItem,
    NumberInput,
    SelectTax,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
    showBtnSearch: {
      type: Boolean,
      default: false,
    },
    isWithSoReference: {
      type: Boolean,
      default: false,
    },
    return_type_str: {
      type: String,
      default: "1",
    },
  },
  data() {
    return {
      disabledInput: false,
      optionsReason: [],
      selectedReason: null,
      showSkuTable: false,
      selectedItemUnits: [],
      selectedItemUnitsInv: [],
      // jpg, jpeg, png, pdf, doc, docx, xls, xlsx
      acceptedTypes: [
        "image/jpeg",
        "image/png",
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ],
      total_line: {
        list_price : 0,
        adj_price : 0,
        tax : 0,
        sales_return: 0,
        discount: 0,
      },
			params : {
				reason_group : 'Customer Return',
			},
      selectedItemTax: null,
      optionsTax: [],
      selectedTax: null,
    };
  },
  async mounted() {
    await this.getReason();
    await this.getTaxes();
    if (this.form.isEdit && this.form.so_types == 'without_so_reference') {
      this.showBtnSearch = true;
    } else if (this.form.isEdit && this.form.so_types == 'with_so_reference'){
      this.showBtnSearch = false;
    }
    if (this.form.isDetail == 1) {
      this.showBtnSearch = false;
      this.disabledInput = true;
    }
    if (this.form.isDetail == 1 || this.form.isEdit) {
      this.setSelectedItemUnits();
    }
    console.log('setSelectedItemUnits()')
    console.log('then calculateSummary')
    this.calculateSummary(this.selectedItemUnits);
  },
  methods: {
    handleDeleteAttachment(tr, index) {
      let copierSelectedItemUnits = JSON.parse(
        JSON.stringify(this.selectedItemUnits)
      );

      for (let i = 0; i < copierSelectedItemUnits.length; i++) {
        if (copierSelectedItemUnits[i].sku_code == tr.sku_code) {
          let getIndex = 0;
          for (
            let j = 0;
            j < copierSelectedItemUnits[i].attachments.length;
            j++
          ) {
            if (j == index) {
              getIndex = j;
              break;
            }
          }

          // remove
          copierSelectedItemUnits[i].attachments.splice(getIndex, 1);
        }
      }
      this.form.return_line_item_data = copierSelectedItemUnits;
      this.selectedItemUnits = copierSelectedItemUnits;
      this.$forceUpdate();
    },
    showDeleteOnly(tr) {
      if ((this.form.isEdit && this.form.so_types != 'without_so_reference') || this.form.isDetail == 1) {
        return false;
      }

      if (tr.parent && this.form.so_types == 'without_so_reference') {
        if (this.form.isDetail) {
          return false;
        }
        return true;
      }
    },
    showDelete(tr) {
      if (tr.parent && this.form.so_types == 'without_so_reference') {
        if (this.form.isDetail) {
          return false;
        }
        return true;
      }
    },
    handleDelete(tr) {
      // delete this.selectedItemUnits by sku code same
      this.selectedItemUnits = this.selectedItemUnits.filter(
        (item) => item.sku_code != tr.sku_code
      );
    },
    handleClose() {
      this.showSkuTable = false;
    },
    async getReason() {
      try {
        const resp = await masterRepository.getMasterReason({
          params: this.params,
        });
        if (resp.code == 200) {
          this.optionsReason = [];
          for (let i = 0; i < resp.data.records.length; i++) {
            this.optionsReason.push(resp.data.records[i].reason);
          }
        } else {
          this.$vs.notify({
            title: "Error",
            text: "Error while fetching master reason",
            color: "danger",
            iconPack: "feather",
            icon: "icon-alert-circle",
          });
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: "Error while fetching master reason",
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });
        console.log(error);
      }
    },
    setSelectMasterReason(data, index) {
      this.selectedItemUnits[index].reason = data.reason;
      this.form.return_line_item_data = this.selectedItemUnits;
    },
    convertDTO(item) {
      // console.log("convertDTO(item)", item)
      // let taxAmt = this.form.so_types == 'without_so_reference' ? Math.floor((item.price * item.quantity) * item.tax_rate / 100) : item.TaxAmount;
      // CR-2500051 - Tax using Math.round() _ rounding terdekat
      let taxAmt = this.form.so_types == 'without_so_reference' ? Math.round((item.price * item.quantity) * item.tax_rate / 100) : item.TaxAmount;
      let isFg = ((item.Subtotal == item.Discount) && item.Qty > 0) ? true : false;
      let gross_up = 0, rounding = 0, allow_return = true, related_item_id =[];
      if (this.form.so_types != 'without_so_reference') {
        if (item.Information && item.Information != null) {
          console.log("masuk item.Information", item.Information)
          isFg = item.Information.is_free_item
          gross_up = item.Information.gross_up
          rounding = item.Information.rounding
          if (item.Information.promotion != null && item.Information.promotion) {
            if (item.Information.promotion.length > 0) {
              item.Information.promotion.forEach(promos => {
                if (!promos.allow_return) {
                  allow_return = promos.allow_return;
                }
                related_item_id = promos.related_item_id;
              });
            }
          }
          if (item.Information.promotion_free_item != null && item.Information.promotion_free_item) {
            if (item.Information.promotion_free_item.length > 0) {
              item.Information.promotion_free_item.forEach(promoFg => {
                if (!promoFg.allow_return) {
                  allow_return = promoFg.allow_return;
                }
              });
            }
          }
        } else {
          isFg = false;
        }
      }
      return {
        id: 0,
        parent: false,
        invoice_line_id: item.ID,
        sku_code: item.SkuCode,
        item_name: item.ItemName,
        unit_name: item.Unit,
        qty_invoice: parseFloat(item.Qty),
        quantity: 0,
        so_price: parseFloat(item.Price),
        // price: this.form.so_types != 'without_so_reference' ? ( item.ItemUnitAmountUom > 1 ? parseFloat( item.ItemUnitAmountUom  * item.SrPrice) : parseFloat(item.SrPrice)) : parseFloat(item.Price),
        price: parseFloat(item.Price),
        sr_price: (this.form.so_types != 'without_so_reference' && item.ItemUnitAmountUom > 0) ? parseFloat(item.SrPrice * item.ItemUnitAmountUom) : ( item.SrPrice > 0 ? parseFloat(item.SrPrice) : 0),
        subtotal: parseFloat(item.Subtotal),
        sr_subtotal: this.form.so_types != 'without_so_reference' ? parseFloat(item.SrSubtotal) : 0,
        // adj price is selisih antara (so_price - discount) dengan price
        // adj_price: 0,
        adj_price: this.form.so_types == 'without_so_reference' ? item.Price : 0, // adj_price didefault dengan price, tapi editable
        taxAmount: !isFg ? taxAmt : 0,
        discount: 0, //item.Discount, kalkulasi baru, discount diProrate dan dihitung ulang
        total_discount: 0, //item.Discount, kalkulasi baru, discount diProrate dan dihitung ulang
        inv_discount: this.form.so_types == 'without_so_reference' ? 0 : item.Discount, //item.Discount, kalkulasi baru, discount diProrate dan dihitung ulang
        reason: "",
        attachments: [],
        tax_rate: item.tax_rate != undefined && !isFg ? item.tax_rate : 0,
        taxRate: item.tax_rate != undefined && !isFg ? item.tax_rate : 0,
        taxName: (this.form.so_types == 'without_so_reference' && item.tax_name != undefined) && !isFg ? item.tax_name : null,
        isFreeGood: isFg,
        is_free_good: isFg,
        gross_up: gross_up,
        amount_uom: item.ItemUnitAmountUom,
        qty_general_invoice: item.Qty * item.ItemUnitAmountUom,
        qty_general_return: 0,
        qty_general_used: this.form.so_types != 'without_so_reference' ? item.QtyUsed : 0,
        total_qty_general_return: 0,
        total_qty_general_invoice: 0,
        total_qty_general_used: 0,
        is_expand: false,
        rowSpanPlus: 0,
        item_id: item.ItemID != undefined && item.ItemID != 0 ? item.ItemID : null,
        info: {
          discount: this.form.so_types != 'without_so_reference' ? (!isFg ? item.Discount : 0) : 0,
          disc_fg: (this.form.so_types != 'without_so_reference') ? item.disc_fg : 0,
          total_disc_fg: 0,
          gross_up: this.form.so_types != 'without_so_reference' ? gross_up : 0,
          rounding: this.form.so_types != 'without_so_reference' ? rounding : 0,
          is_free_good: isFg,
          allow_return: allow_return,
          related_item_id: related_item_id,
        },
      };
    },
    async setAttachment(data, skuCode, unitName) {
      // update attachment to each sku code
      for (let i = 0; i < this.selectedItemUnits.length; i++) {
        // if (this.selectedItemUnits[i].sku_code == skuCode) {
        // MIX2-5452 | attachment dan reason dipisahkan, tiap item HU bisa punya sendiri-sendiri
        if (this.selectedItemUnits[i].sku_code == skuCode && this.selectedItemUnits[i].unit_name == unitName) {
          this.selectedItemUnits[i].attachments = data;
        }
      }
      this.form.return_line_item_data = this.selectedItemUnits;
      // force update selected item units
      this.$forceUpdate();
    },
    async setGlobalSelectTax(data){
      console.log("data selected Tax : ", data);
      this.selectedItemTax = data;
    },
    async setSelectTax(tr, idxtr) {
      console.log("this.selectedItemTax : ", this.selectedItemTax);
      console.log("tr : ", tr);
      console.log("idxtr : ", idxtr);
      this.selectedItemUnits[idxtr].tax = this.selectedItemTax;
      this.selectedItemUnits[idxtr].taxName = this.selectedItemTax.Name;
      this.selectedItemUnits[idxtr].taxRate = this.selectedItemTax.Rate;

      for (let i = 0; i < this.selectedItemUnits.length; i++) {
        if (this.selectedItemUnits[i].sku_code == tr.sku_code) {
          this.selectedItemUnits[i].tax = this.selectedItemTax;
          this.selectedItemUnits[i].taxName = this.selectedItemTax.Name;
          this.selectedItemUnits[i].taxRate = this.selectedItemTax.Rate;
        }
      }
      this.form.return_line_item_data = this.selectedItemUnits;
      console.log("this.selectedItemTax Name : ", this.selectedItemTax.Name);
      console.log("this.selectedItemTax Rate : ", this.selectedItemTax.Rate);
    },
    /* 
      Old ver setSelectedItemUnits
      async setSelectedItemUnits() {
        // console.log("this.form", this.form);
        // console.log("this.form.isEdit", this.form.isEdit);
        // console.log("this.form.isDetail", this.form.isDetail);
        if (this.form.isEdit || this.form.isDetail == 1) {
          // Ini persiapan data, di grouping by SKU
          // group by sku code
          console.log("this.form.return_line_item_data : ", this.form.return_line_item_data);
          let groupBySkuCode = this.form.return_line_item_data.reduce((acc, item) => {
            let nama = 
              ( this.form.so_types == "with_so_reference" ? 
              (item.info != null ? item.item_sku_code + item.info.is_free_good  : item.item_sku_code ) : 
              item.item_sku_code );
            
            if (!acc[nama]) {
              acc[nama] = [];
            }
            item.qty_general_return = item.quantity * item.amount_uom;
            if(acc[nama].length == 0) {
              item.parent = true
            }
            acc[nama].push(item);
            return acc;
          }, {});
          console.log("groupBySkuCode : ", groupBySkuCode);

          let qtyGeneralInvBySKUFG = this.form.return_line_item_data.reduce((acc, item) => {
            let nama = 
              ( this.form.so_types == "with_so_reference" ? 
              (item.info != null ? item.item_sku_code + item.info.is_free_good  : item.item_sku_code ) : 
              item.item_sku_code );
            if (!acc[nama]) {
              acc[nama] = 0;
            }
            acc[nama] += item.qty_invoice * item.amount_uom;
            return acc;
          }, {});

          let qtyGeneralReturnBySKUFG = this.form.return_line_item_data.reduce((acc, item) => {
            let nama = 
              ( this.form.so_types == "with_so_reference" ? 
              (item.info != null ? item.item_sku_code + item.info.is_free_good  : item.item_sku_code ) : 
              item.item_sku_code );
            if (!acc[nama]) {
              acc[nama] = 0;
            }
            item.qty_general_return = item.quantity * item.amount_uom;
            acc[nama] += item.qty_general_return;
            return acc;
          }, {});
          
          console.log("groupBySkuCode 617", groupBySkuCode)
          console.log("qtyGeneralReturnBySKUFG 617", qtyGeneralReturnBySKUFG)
          console.log("qtyGeneralInvBySKUFG 617", qtyGeneralInvBySKUFG)
          
          // console.log(495)
          // console.log("this.optionsTax", this.optionsTax)
          this.selectedItemUnits = [];
          this.form.return_line_item_data.map((item) => {
            console.log("item", item)

            let nama = 
              ( this.form.so_types == "with_so_reference" ? 
              (item.info != null ? item.item_sku_code + item.info.is_free_good  : item.item_sku_code ) : 
              item.item_sku_code );

            // let len = groupBySkuCode[item.item_sku_code].length
            let len = groupBySkuCode[nama].length
            let data = {
              parent: item.parent,
              invoice_line_id: item.invoice_line_id,
              sales_return_line_id: item.sales_return_line_id,
              sku_code: item.item_sku_code,
              item_name: item.item_name,
              unit_name: item.item_unit,
              quantity: parseFloat(item.quantity),
              qty_invoice: parseFloat(item.qty_invoice),
              so_price: item.price,
              price: parseFloat(item.price),
              sr_price: parseFloat(item.sr_price),
              sr_subtotal: parseFloat(item.sr_subtotal),
              // taxAmount: this.form.so_types == 'without_so_reference' ? Math.floor((item.price * item.quantity) * item.tax_rate / 100) : (!item.info.is_free_good ? item.tax : 0),
              // taxAmount: this.form.so_types == 'without_so_reference' ? Math.floor((item.price * item.quantity) * item.tax_rate / 100) : item.tax,
              // CR-2500051 - Tax using Math.round() _ rounding terdekat
              taxAmount: this.form.so_types == 'without_so_reference' ? Math.round((item.price * item.quantity) * item.tax_rate / 100) : item.tax,
              taxRate: item.tax_rate,
              taxName: this.form.so_types == 'without_so_reference' ? item.tax_name : null,
              discount: item.reg_discount,
              adj_price: parseFloat(item.adj_price),
              reason: item.reason,
              attachments: item.attachments,
              amount_uom: item.amount_uom,
              qty_general_invoice: item.qty_invoice * item.amount_uom,
              qty_general_return: item.quantity * item.amount_uom,
              qty_general_used: this.form.so_types != 'without_so_reference' ? item.quantity_received : 0,
              lilUom: groupBySkuCode[nama][len-1].item_unit,
              total_qty_general_invoice: this.form.so_types != 'without_so_reference' ? qtyGeneralInvBySKUFG[nama] : 0,
              total_qty_general_return: qtyGeneralReturnBySKUFG[nama],
              total_qty_general_used: this.form.so_types != 'without_so_reference' ? (item.info != null ? item.info.total_qty_general_used : 0 ) : 0,
              is_expand: false,
              rowSpanPlus: 0,
              info: item.info,
              isFreeGood: item.info != null ? item.info.is_free_good : false,
              is_free_good: item.info != null ? item.info.is_free_good : false,
              GenerateTaxInvoice: null,
            };
            // data.tax = this.optionsTax.filter(
            //   (taxes) => taxes.Name == item.tax_name
            // ),
            // data.tax = data.tax[0];
            this.selectedItemUnits.push(data);
          });
          
          let skus = []
          let groupBySkus = this.selectedItemUnits.reduce((acc, item) => {
            
            let nama = (!this.form.isEdit && this.form.isDetail == 0) ? 
              item.sku_code + item.isFreeGood : 
              ( this.form.so_types == "with_so_reference" ? 
              (item.info != null ? item.sku_code + item.info.is_free_good  : item.sku_code ) : 
              item.sku_code );

            if (!acc[nama]) {
              acc[nama] = [];
              skus.push(nama);
            }
            acc[nama].push(item);
            return acc;
          }, {});
          
          let qtyReturnGeneral = {};
          console.log("groupBySkus", groupBySkus)
          console.log("qtyReturnGeneral", qtyReturnGeneral)
          skus.forEach(s => {
            qtyReturnGeneral[s] = 0
            groupBySkus[s].forEach(element => {
              qtyReturnGeneral[s] += element.qty_general_return;
            });
          });
          console.log("qtyReturnGeneral", qtyReturnGeneral)
          // groupBySkus[el.sku_code].forEach(eli => {
          //   this.selectedItemUnits[idx].qty_general_return += eli.qty_general_return
          // });
          
          this.selectedItemUnits.forEach(el => {
            if(el.parent) {
              console.log("el", el)            

              let nama = (!this.form.isEdit && this.form.isDetail == 0) ? 
              el.sku_code + el.isFreeGood : 
              ( this.form.so_types == "with_so_reference" ? 
              (el.info != null ? el.sku_code + el.info.is_free_good  : el.sku_code ) : 
              el.sku_code );

              console.log("groupBySkus", groupBySkus)            
              console.log("nama", nama)            

              el.units = groupBySkus[nama];
              el.qty_general_return = qtyReturnGeneral[nama]
            }
          });
        } else {
          console.log(520)
          if (
            this.form.customer_invoice_data.invoice_code != null ||
            this.form.customer_invoice_data.invoice_code != ""
          ) {
          console.log(525)
          const temps = this.form.customer_invoice_data.sales_order_lines_temp;
            this.selectedItemUnits = [];
            await temps.forEach((item) => {
              let newDataDto = this.convertDTO(item);
              this.selectedItemUnits.push(newDataDto);
              // disini
            });
          }
        }
        console.log("this.selectedItemUnits", this.selectedItemUnits)
        if(this.selectedItemUnits.length > 0 && this.form.so_types == 'without_so_reference'){
          this.selectedItemUnits.forEach((el, i) => {
            this.selectedItemUnits[i].tax = this.optionsTax.filter(
              (taxes) => taxes.Name == el.taxName
            );
            this.selectedItemUnits[i].tax = this.selectedItemUnits[i].tax[0];
            this.selectedItemUnits[i].GenerateTaxInvoice = this.selectedItemUnits[i].tax.GenerateTaxInvoice;
          });
        }
      },
    */
    // New ver setSelectedItemUnits _ MIX2-2504300 _ Fix urutan HU Mengacak
    async setSelectedItemUnits() {
      // console.log("this.form", this.form);
      // console.log("this.form.isEdit", this.form.isEdit);
      // console.log("this.form.isDetail", this.form.isDetail);
      if (this.form.isEdit || this.form.isDetail == 1) {
        // Ini persiapan data, di grouping by SKU
        // group by sku code
        console.log("this.form.return_line_item_data : ", this.form.return_line_item_data);

        let idxGroupBySkuCode = [], groupBySkuCode = this.form.return_line_item_data.reduce((acc, item) => {
          let nama = 
            ( this.form.so_types == "with_so_reference" ? 
            (item.info != null ? item.item_sku_code + item.info.is_free_good  : item.item_sku_code ) : 
            item.item_sku_code );
          
          if(item.info != null && item.info.is_free_good){
            this.fgExist = true;
          }
          
          if (!acc[nama]) {
            acc[nama] = [];
            idxGroupBySkuCode.push(nama);
          }
          item.qty_general_return = item.quantity * item.amount_uom;
          if(acc[nama].length == 0) {
            item.parent = true
          }
          acc[nama].push(item);
          return acc;
        }, {});
        console.log("groupBySkuCode : ", groupBySkuCode);

        this.form.return_line_item_data.reduce((acc, item) => {
          let nama = 
            ( this.form.so_types == "with_so_reference" ? 
            (item.info != null ? item.item_sku_code + item.info.is_free_good  : item.item_sku_code ) : 
            item.item_sku_code );
          
          console.log("groupBySkuCode[nama]", nama, groupBySkuCode[nama]);
          groupBySkuCode[nama].sort((a, b) => b.amount_uom - a.amount_uom);

          groupBySkuCode[nama].forEach((el, ix) => {
            console.log(ix, el);
            if (ix == 0){
              el.parent = true;
            } else {
              el.parent = false;
            }
          });

          console.log("groupBySkuCode[nama] after", groupBySkuCode[nama]);
        });

        // groupBySkuCode.forEach((idx, item) => {
        //   console.log("idx, item : ", idx, item);
        //   let urut = item;
        //   urut.sort((a, b) => a.amount_uom - b.amount_uom)
        //   console.log("urut", urut);

        //   groupBySkuCode[idx].sort((a, b) => a.amount_uom - b.amount_uom)
        //   console.log("groupBySkuCode[idx]", idx, groupBySkuCode[idx]);
        // });

        console.log("groupBySkuCode after sort : ", groupBySkuCode);
        
        let qtyGeneralInvBySKUFG = this.form.return_line_item_data.reduce((acc, item) => {
          let nama = 
            ( this.form.so_types == "with_so_reference" ? 
            (item.info != null ? item.item_sku_code + item.info.is_free_good  : item.item_sku_code ) : 
            item.item_sku_code );
          if (!acc[nama]) {
            acc[nama] = 0;
          }
          acc[nama] += item.qty_invoice * item.amount_uom;
          return acc;
        }, {});

        let qtyGeneralReturnBySKUFG = this.form.return_line_item_data.reduce((acc, item) => {
          let nama = 
            ( this.form.so_types == "with_so_reference" ? 
            (item.info != null ? item.item_sku_code + item.info.is_free_good  : item.item_sku_code ) : 
            item.item_sku_code );
          if (!acc[nama]) {
            acc[nama] = 0;
          }
          item.qty_general_return = item.quantity * item.amount_uom;
          acc[nama] += item.qty_general_return;
          return acc;
        }, {});

        let qtyGeneralUsedBySKUFG = this.form.return_line_item_data.reduce((acc, item) => {
          let nama = 
            ( this.form.so_types == "with_so_reference" ? 
            (item.info != null ? item.item_sku_code + item.info.is_free_good  : item.item_sku_code ) : 
            item.item_sku_code );
          if (!acc[nama]) {
            acc[nama] = 0;
          }
          acc[nama] += item.quantity_received;
          return acc;
        }, {});

        let qtyGeneralRemainingBySKUFG = this.form.return_line_item_data.reduce((acc, item) => {
          let nama = 
            ( this.form.so_types == "with_so_reference" ? 
            (item.info != null ? item.item_sku_code + item.info.is_free_good  : item.item_sku_code ) : 
            item.item_sku_code );
          if (!acc[nama]) {
            acc[nama] = qtyGeneralInvBySKUFG[nama] - qtyGeneralUsedBySKUFG[nama];
          }
          return acc;
        }, {});
        
        console.log("groupBySkuCode 617", groupBySkuCode, idxGroupBySkuCode)
        console.log("qtyGeneralReturnBySKUFG 617", qtyGeneralReturnBySKUFG)
        console.log("qtyGeneralInvBySKUFG 617", qtyGeneralInvBySKUFG)
        console.log("qtyGeneralUsedBySKUFG", qtyGeneralUsedBySKUFG)
        console.log("qtyGeneralRemainingBySKUFG", qtyGeneralRemainingBySKUFG)
        
        // console.log(495)
        // console.log("this.optionsTax", this.optionsTax)
        this.selectedItemUnits = [];

        /*
          Push by SR Line resp
          this.form.return_line_item_data.map((item) => {
            console.log("item", item)
  
            let nama = 
              ( this.form.so_types == "with_so_reference" ? 
              (item.info != null ? item.item_sku_code + item.info.is_free_good  : item.item_sku_code ) : 
              item.item_sku_code );
  
            // let len = groupBySkuCode[item.item_sku_code].length
            let len = groupBySkuCode[nama].length
            let data = {
              parent: item.parent,
              invoice_line_id: item.invoice_line_id,
              sales_return_line_id: item.sales_return_line_id,
              sku_code: item.item_sku_code,
              item_name: item.item_name,
              unit_name: item.item_unit,
              quantity: parseFloat(item.quantity),
              qty_invoice: parseFloat(item.qty_invoice),
              so_price: item.price,
              price: parseFloat(item.price),
              sr_price: parseFloat(item.sr_price),
              sr_subtotal: parseFloat(item.sr_subtotal),
              // taxAmount: this.form.so_types == 'without_so_reference' ? Math.floor((item.price * item.quantity) * item.tax_rate / 100) : (!item.info.is_free_good ? item.tax : 0),
              // taxAmount: this.form.so_types == 'without_so_reference' ? ((item.price * item.quantity) * item.tax_rate / 100) : (!item.info.is_free_good ? item.tax : 0),
              
             taxAmount: this.form.so_types == 'without_so_reference' ? 
             ((item.adj_price * item.quantity) * (item.tax_rate / 100)) : 
             item.info != undefined ? 
             (item.info.is_free_good != undefined ?
               (item.info.is_free_good ? item.tax : (item.price * item.quantity) * (item.tax_rate / 100) ) 
             : ((item.adj_price * item.quantity) * item.tax_rate / 100) ) 
             : ((item.adj_price * item.quantity) * item.tax_rate / 100),
              taxRate: item.tax_rate,
              tax_rate: item.tax_rate,
              taxName: this.form.so_types == 'without_so_reference' ? item.tax_name : null,
              discount: item.reg_discount,
              adj_price: parseFloat(item.adj_price),
              reason: item.reason,
              attachments: item.attachments,
              amount_uom: item.amount_uom,
              qty_general_invoice: item.qty_invoice * item.amount_uom,
              qty_general_return: item.quantity * item.amount_uom,
              qty_general_used: this.form.so_types != 'without_so_reference' ? item.quantity_received : 0,
              lilUom: groupBySkuCode[nama][len-1].item_unit,
              total_qty_general_invoice: this.form.so_types != 'without_so_reference' ? qtyGeneralInvBySKUFG[nama] : 0,
              total_qty_general_return: qtyGeneralReturnBySKUFG[nama],
              // total_qty_general_used: this.form.so_types != 'without_so_reference' ? qtyGeneralRemainingBySKUFG[nama] : 0, MIX2-2504303
              total_qty_general_used: this.form.so_types != 'without_so_reference' ? (qtyGeneralInvBySKUFG[nama] - qtyGeneralRemainingBySKUFG[nama]) : 0,
              is_expand: false,
              rowSpanPlus: 0,
              info: item.info != null ? item.info : {//default info SR Without Reff
                discount: 0,
                disc_fg: 0,
                total_disc_fg: 0,
                gross_up: 0,
                rounding: 0,
                is_free_good: false,
                allow_return: true,
              },
              isFreeGood: item.info != null ? item.info.is_free_good : false,
              is_free_good: item.info != null ? item.info.is_free_good : false,
              GenerateTaxInvoice: null,
              gross_up: (item.info != null && item.info.gross_up) ? item.info.gross_up : 0,
            };
            // data.tax = this.optionsTax.filter(
            //   (taxes) => taxes.Name == item.tax_name
            // ),
            // data.tax = data.tax[0];
            this.selectedItemUnits.push(data);
          });
        */

        // Push by groupBySkuCode - MIX2-2504300 - Fix issue urutan HU mengacak
        for (let i = 0; i < idxGroupBySkuCode.length; i++) {
          console.log("item", idxGroupBySkuCode[i]);
          
          // let nama = 
          //     ( this.form.so_types == "with_so_reference" ? 
          //     (item.info != null ? item.item_sku_code + item.info.is_free_good  : item.item_sku_code ) : 
          //     item.item_sku_code );
          
          let nama = idxGroupBySkuCode[i];
          let arr_item = groupBySkuCode[nama];
          
          console.log("arr_item", arr_item)
                        
          // let len = groupBySkuCode[item.item_sku_code].length
          for (let j = 0; j < arr_item.length; j++) {
            
            const item = arr_item[j];
            console.log("item", item)
            
            let len = arr_item.length
            let data = {
              parent: item.parent,
              invoice_line_id: item.invoice_line_id,
              sales_return_line_id: item.sales_return_line_id,
              sku_code: item.item_sku_code,
              item_name: item.item_name,
              unit_name: item.item_unit,
              quantity: parseFloat(item.quantity),
              qty_invoice: parseFloat(item.qty_invoice),
              so_price: item.price,
              price: parseFloat(item.price),
              sr_price: parseFloat(item.sr_price),
              sr_subtotal: parseFloat(item.sr_subtotal),
              // taxAmount: this.form.so_types == 'without_so_reference' ? Math.floor((item.price * item.quantity) * item.tax_rate / 100) : (!item.info.is_free_good ? item.tax : 0),
              // taxAmount: this.form.so_types == 'without_so_reference' ? ((item.price * item.quantity) * item.tax_rate / 100) : (!item.info.is_free_good ? item.tax : 0),
              
             taxAmount: this.form.so_types == 'without_so_reference' ? 
             ((item.adj_price * item.quantity) * (item.tax_rate / 100)) : 
             item.info != undefined ? 
             (item.info.is_free_good != undefined ?
               (item.info.is_free_good ? item.tax : (item.price * item.quantity) * (item.tax_rate / 100) ) 
             : ((item.adj_price * item.quantity) * item.tax_rate / 100) ) 
             : ((item.adj_price * item.quantity) * item.tax_rate / 100),
              taxRate: item.tax_rate,
              tax_rate: item.tax_rate,
              taxName: this.form.so_types == 'without_so_reference' ? item.tax_name : null,
              discount: item.reg_discount,
              adj_price: parseFloat(item.adj_price),
              reason: item.reason,
              attachments: item.attachments,
              amount_uom: item.amount_uom,
              qty_general_invoice: item.qty_invoice * item.amount_uom,
              qty_general_return: item.quantity * item.amount_uom,
              qty_general_used: this.form.so_types != 'without_so_reference' ? item.quantity_received : 0,
              lilUom: arr_item[ len - 1 ].item_unit, //groupBySkuCode[nama][len-1].item_unit,
              total_qty_general_invoice: this.form.so_types != 'without_so_reference' ? qtyGeneralInvBySKUFG[nama] : 0,
              total_qty_general_return: qtyGeneralReturnBySKUFG[nama],
              // total_qty_general_used: this.form.so_types != 'without_so_reference' ? qtyGeneralRemainingBySKUFG[nama] : 0, MIX2-2504303
              total_qty_general_used: this.form.so_types != 'without_so_reference' ? (qtyGeneralInvBySKUFG[nama] - qtyGeneralRemainingBySKUFG[nama]) : 0,
              is_expand: false,
              rowSpanPlus: 0,
              info: item.info != null ? item.info : {//default info SR Without Reff
                discount: 0,
                disc_fg: 0,
                total_disc_fg: 0,
                gross_up: 0,
                rounding: 0,
                is_free_good: false,
                allow_return: true,
              },
              isFreeGood: item.info != null ? item.info.is_free_good : false,
              is_free_good: item.info != null ? item.info.is_free_good : false,
              GenerateTaxInvoice: null,
              gross_up: (item.info != null && item.info.gross_up) ? item.info.gross_up : 0,
            };
            // data.tax = this.optionsTax.filter(
            //   (taxes) => taxes.Name == item.tax_name
            // ),
            // data.tax = data.tax[0];
            this.selectedItemUnits.push(data);
          }
        }
        // groupBySkus[el.sku_code].forEach(eli => {
        //   this.selectedItemUnits[idx].qty_general_return += eli.qty_general_return
        // });
        
        this.selectedItemUnits.forEach(el => {
          if(el.parent) {
            console.log("el", el)            

            let nama = (!this.form.isEdit && this.form.isDetail == 0) ? 
            el.sku_code + el.isFreeGood : 
            ( this.form.so_types == "with_so_reference" ? 
            (el.info != null ? el.sku_code + el.info.is_free_good  : el.sku_code ) : 
            el.sku_code );

            console.log("groupBySkus", groupBySkus)            
            console.log("nama", nama)            

            el.units = groupBySkus[nama];
            el.qty_general_return = qtyReturnGeneral[nama]
          }
        });
        
        let skus = []
        let groupBySkus = this.selectedItemUnits.reduce((acc, item) => {
          
          let nama = (!this.form.isEdit && this.form.isDetail == 0) ? 
            item.sku_code + item.isFreeGood : 
            ( this.form.so_types == "with_so_reference" ? 
            (item.info != null ? item.sku_code + item.info.is_free_good  : item.sku_code ) : 
            item.sku_code );

          if (!acc[nama]) {
            acc[nama] = [];
            skus.push(nama);
          }
          acc[nama].push(item);
          return acc;
        }, {});
        
        let qtyReturnGeneral = {};
        console.log("groupBySkus", groupBySkus)
        console.log("qtyReturnGeneral", qtyReturnGeneral)
        skus.forEach(s => {
          qtyReturnGeneral[s] = 0
          groupBySkus[s].forEach(element => {
            qtyReturnGeneral[s] += element.qty_general_return;
          });
        });
        console.log("qtyReturnGeneral", qtyReturnGeneral)
        // groupBySkus[el.sku_code].forEach(eli => {
        //   this.selectedItemUnits[idx].qty_general_return += eli.qty_general_return
        // });
        
        this.selectedItemUnits.forEach(el => {
          if(el.parent) {
            console.log("el", el)            

            let nama = (!this.form.isEdit && this.form.isDetail == 0) ? 
            el.sku_code + el.isFreeGood : 
            ( this.form.so_types == "with_so_reference" ? 
            (el.info != null ? el.sku_code + el.info.is_free_good  : el.sku_code ) : 
            el.sku_code );

            console.log("groupBySkus", groupBySkus)            
            console.log("nama", nama)            

            el.units = groupBySkus[nama];
            el.qty_general_return = qtyReturnGeneral[nama]
          }
        });
      } else {
        console.log(520)
        if (
          this.form.customer_invoice_data.invoice_code != null ||
          this.form.customer_invoice_data.invoice_code != ""
        ) {
        console.log(525)
        const temps = this.form.customer_invoice_data.sales_order_lines_temp;
          this.selectedItemUnits = [];
          await temps.forEach((item) => {
            let newDataDto = this.convertDTO(item);
            this.selectedItemUnits.push(newDataDto);
            // disini
          });
        }
      }
      console.log("this.selectedItemUnits", this.selectedItemUnits)
      if(this.selectedItemUnits.length > 0 && this.form.so_types == 'without_so_reference'){
        this.selectedItemUnits.forEach((el, i) => {
          this.selectedItemUnits[i].tax = this.optionsTax.filter(
            (taxes) => taxes.Name == el.taxName
          );
          this.selectedItemUnits[i].tax = this.selectedItemUnits[i].tax[0];
          this.selectedItemUnits[i].GenerateTaxInvoice = this.selectedItemUnits[i].tax.GenerateTaxInvoice;
        });
      }
    },
    formatCurrencyIDR,
    // MIX2-2504300 _ fix issue HU Mengacak - by ChatGPT
    async setItem(data) {
      if (!this.addValidation(data)) return;
    
      this.$vs.loading();
    
      try {
        // 1. Ambil list item unit
        const responseHU = await SalesReturnV2Repo.getItemHU({
          sku_code: data.SkuCode,
        });
    
        if (responseHU.code !== 200) return;
        const responseUnits = responseHU.data;
    
        // 2. Siapkan array untuk menampung promise getPriceItem
        const pricePromises = responseUnits.map(async (item, index) => {
          const date = new Date().toISOString().split("T")[0];
          const warehouse_id = this.form.customer_return_data.territory_warehouse.warehouse_id;
    
          // Request harga
          const responsePriceItem = await SalesReturnV2Repo.getPriceItem({
            date,
            warehouse_id,
            sku_code: data.SkuCode,
            item_unit_id: item.item_unit_id,
            territory_id: this.form.customer_return_data.territory_warehouse.territory_id,
            pricing_group_id: this.form.customer_data.pricing_group_id,
            cg1: this.form.customer_data.customer_group_id_1,
            cg2: this.form.customer_data.customer_group_id_2,
            cg3: this.form.customer_data.customer_group_id_3,
            customer_id: this.form.customer_data.customer_id,
            is_simulation: false,
          });
    
          const price = responsePriceItem.code === 200 ? responsePriceItem.data.price : 0;
    
          return {
            id: item.item_unit_id,
            parent: index === 0,
            invoice_line_id: 0,
            sales_order_line_id: 0,
            sku_code: data.SkuCode,
            item_name: data.Name,
            unit_name: item.unit_name,
            unit_level: item.level,
            amount_uom: item.amount_uom,
            quantity: 0,
            so_price: price,
            price: price,
            adj_price: this.form.so_types === "without_so_reference" ? price : 0,
            taxAmount: 0,
            taxRate: item.tax_rate,
            taxName: item.tax_name,
            discount: 0,
            reason: "",
            attachments: [],
            info: {
              discount: 0,
              is_free_good: false,
              allow_return: true,
            },
            GenerateTaxInvoice: false,
          };
        });
    
        // 3. Tunggu semua proses harga selesai
        let groupUnitSkus = await Promise.all(pricePromises);
    
        console.log("Final groupUnitSkus before sort:", groupUnitSkus);
    
        // 4. Sorting dari terbesar -> terkecil (amount_uom)
        groupUnitSkus.sort((a, b) => b.amount_uom - a.amount_uom);
    
        console.log("After sort:", groupUnitSkus);
        console.log("len", groupUnitSkus.length);
        for (let i = 0; i < groupUnitSkus.length; i++) {
          if (i == 0) {
            groupUnitSkus[i].parent = true;
          } else {
            groupUnitSkus[i].parent = false;
          }
          
        }
    
        // 5. Push ke main data
        this.selectedItemUnits.push(...groupUnitSkus);
        this.form.return_line_item_data = this.selectedItemUnits;
    
        console.log("this.selectedItemUnits:", this.selectedItemUnits);
    
      } catch (err) {
        console.error("Error in setItem:", err);
      } finally {
        this.$vs.loading.close();
      }
    },
    addValidation(data) {
      // if sku_code and  unit_name is exist
      if (
        this.selectedItemUnits.some((item) => item.sku_code == data.SkuCode)
      ) {
        this.$vs.notify({
          title: "Error",
          text: "SKU Code and Unit Name is exist",
          color: "danger",
        });
        return false;
      }

      return true;
    },
    async calculateSummary(data) {
      // calculate adj price each row
      console.log("data", data)
      console.log("this.selectedItemUnits", this.selectedItemUnits)
      console.log("this.form", this.form)
      console.log("this.return_type_str", this.return_type_str)
      // console.log("this.form.customer_data.selected_customer")
      // console.log(this.form.customer_data.selected_customer)
      // console.log("selected_customer.is_pkp")
      // console.log(this.form.customer_data.selected_customer.is_pkp)

      let isPkp = false; 
      if (this.form.customer_data.selected_customer != undefined){
        isPkp = this.form.customer_data.selected_customer.is_pkp == "1" ? true : false;
      }
      // console.log("var isPkp", isPkp)
      await data.forEach((item) => {
        if (this.form.so_types == "with_so_reference") {
          item.adj_price = 0;
          if(item.quantity == 0 || !item.info.allow_return){
            item.total_discount = 0;
            item.discount = 0;
            item.info.total_disc_fg = 0;
            item.info.discount = 0;
          } else if (item.quantity > 0 && item.info != null && this.return_type_str == "1"){
            item.total_discount = item.info.disc_fg * item.qty_general_return;
            item.discount = item.info.disc_fg * item.qty_general_return;
            item.info.total_disc_fg = item.info.disc_fg * item.qty_general_return;
            // item.info.discount = item.info.disc_fg * item.qty_general_return;
          }
          return;
        } else {
          item.price = parseFloat(item.price);
        }
      });

      // total list price
      const totalListPrice = data.reduce((acc, item) => {
        if (this.form.so_types == "with_so_reference") {
          return item.info.allow_return ? acc + item.sr_price * item.quantity : acc;
        } else {
          return acc + item.price * item.quantity;
        }
      }, 0);

      // total adj price
      const totalAdjPrice = data.reduce((acc, item) => {
        return acc + item.adj_price * item.quantity;
      }, 0);

      // total discount
      const totalDiscount = data.reduce((acc, item) => {
        if (this.form.so_types == 'with_so_reference'){
          if (item.quantity > 0 && this.return_type_str == "1" && item.info.allow_return){
            item.info.total_disc_fg = item.quantity * item.amount_uom * item.info.disc_fg;
            item.total_discount = item.info.total_disc_fg;
            // return acc + item.info.total_disc_fg;
            return acc;
          } else {
            return acc
          }
        } else {
          return acc + (item.discount * item.quantity);
        }
      }, 0);

      if (this.form.so_types == 'with_so_reference'){
        /* 
          kalau taxID SR nya tidak null, maka cek Dulu, customer nya IS PKP atau ngga.
          MIX2-5451	
          "PPN yang digunakan tergantung pada customer PKP / Non-PKP dan dapat diubah
          Customer PKP = Include PPN (default PPN mengikuti Invoice Ref)
          Non PKP = Hanya DPP, karena tidak menerbitkan NRP (default No PPN)"
        */
        if (isPkp){

        } 
       
        if(this.form.customer_return_data.tax_id != null) {
          data.forEach((item) => {
            console.log("item", item)
            let gross_up = item.gross_up != undefined ? item.gross_up : 0;
            item.tax_rate = this.form.customer_return_data.tax_id.Rate;
            // item.taxAmount = item.quantity > 0 ? Math.floor(((item.price * item.quantity) - item.discount) * this.form.customer_return_data.tax_id.Rate / 100) : 0;
            item.taxAmount = 0
            if (item.info.allow_return) {
              if(this.return_type_str == "1") {
                // item.taxAmount = item.quantity > 0 ? Math.floor((((item.price * item.quantity) - item.discount) * this.form.customer_return_data.tax_id.Rate / 100) + item.gross_up) : 0;
                item.taxAmount = item.quantity > 0 ? Math.floor( ( (this.form.customer_return_data.tax_id.Rate / 100) * (((item.sr_price * item.quantity)) + gross_up) ) ) : 0; //taxRate * (qty * price) + grossUp
              } else {
                // item.taxAmount = item.quantity > 0 ? Math.floor(((item.price * item.quantity) - item.discount) * this.form.customer_return_data.tax_id.Rate / 100) : 0;
                item.taxAmount = item.quantity > 0 ? Math.floor( ( (this.form.customer_return_data.tax_id.Rate / 100) * ((item.sr_price * item.quantity)) ) ) : 0; //taxRate * (qty * price)
              }
            }
            // item.taxAmount = item.quantity > 0 ? Math.floor(((item.price * item.quantity) - item.discount) * this.form.customer_return_data.tax_id.Rate / 100) : 0;
            // CR-2500051 - Tax using Math.round() _ rounding terdekat
            item.taxAmount = item.quantity > 0 ? Math.round(((item.price * item.quantity) - item.discount) * this.form.customer_return_data.tax_id.Rate / 100) : 0;
          });
          // if (!item.isFreeGood) {
          
        }
      } else {
        // data.forEach((item) => {
        //   if(item.tax_rate != undefined && item.tax_rate > 0) {
        //       item.taxAmount = (item.adj_price * item.quantity) * item.tax_rate / 100
        //   }
        // })
        this.selectedItemUnits.forEach((item, i) => {
          console.log(i, item)
          console.log(this.selectedItemUnits[i])
          console.log("this.selectedItemUnits[i].tax", this.selectedItemUnits[i].tax)

          if(item.taxRate != undefined && item.taxRate >= 0 && item.taxName!= "" && this.selectedItemUnits[i].tax == undefined) {
            console.log("789");
            console.log("set this.selectedItemUnits[i].tax");
            this.selectedItemUnits[i].tax = this.optionsTax.filter(
              (taxes) => taxes.Name == item.taxName
            );
            this.selectedItemUnits[i].tax = this.selectedItemUnits[i].tax[0];            
            this.selectedItemUnits[i].GenerateTaxInvoice = this.selectedItemUnits[i].tax.GenerateTaxInvoice;
          }
          
          // Pengecekan GenerateTaxInvoice dari taxType terpilih di SKu ini.
          // MIX2-2502379 issue selisih tax di UI dan cetak SPBR
          console.log("item tax", item.tax)
          // console.log("item GenerateTaxInvoice", item.tax.GenerateTaxInvoice)

          // Old ver, ga nge cek generateTaxInv
          console.log("i", i)
          console.log("this.selectedItemUnits[i]", this.selectedItemUnits[i])
          console.log("item.GenerateTaxInvoice", item.GenerateTaxInvoice)
          // Masih issue kenapa kok Infinit Loop disini
          if(item.GenerateTaxInvoice){
            if(item.tax_rate != undefined && item.tax_rate > 0 && !item.isFreeGood) {
                this.selectedItemUnits[i].taxAmount = Math.floor(((item.adj_price * item.quantity) - item.discount) * item.tax_rate / 100)
            }
            if(item.taxRate != undefined && item.taxRate > 0 && !item.isFreeGood) {
                this.selectedItemUnits[i].taxAmount = Math.floor(((item.adj_price * item.quantity) - item.discount) * item.taxRate / 100)
            }
            if(item.taxRate != undefined && item.taxRate == 0 && item.taxName!= "" && !item.isFreeGood) {
              console.log("793 item")
              this.selectedItemUnits[i].taxAmount = Math.floor(((item.adj_price * item.quantity) - item.discount) * item.taxRate)
            }
          } else {
            console.log("814")
            console.log("815 item", item)
            console.log("item.taxRate", item.taxRate)
            // if(item.taxRate != undefined && item.taxRate >= 0 && item.taxName!= "") {
            //   this.selectedItemUnits[i].tax = this.optionsTax.filter(
            //     (taxes) => taxes.Name == item.taxName
            //   );
            //   this.selectedItemUnits[i].tax = this.selectedItemUnits[i].tax[0];            
            // }
            if(item.taxRate != undefined && item.taxRate == 0 && item.taxName!= "" && !item.isFreeGood) {
              this.selectedItemUnits[i].taxAmount = Math.floor(((item.adj_price * item.quantity) - item.discount) * 0)
            }
            this.selectedItemUnits[i].taxAmount = Math.floor(((item.adj_price * item.quantity) - item.discount) * 0)
          }

          console.log("item", item)
        });
        console.log("this.selectedItemUnits v1", this.selectedItemUnits)

        // Diloops lagi
        this.selectedItemUnits.forEach((item, i) => {
          console.log("item_2", item, i)
        });
        /*
        if(item.tax){
          if(!item.tax.GenerateTaxInvoice){
            this.selectedItemUnits[i].taxAmount = 0;
          } else {
            console.log("Tax type generateTaxInv True", item.tax.GenerateTaxInvoice)
            if(item.tax_rate != undefined && item.tax_rate > 0 && !item.isFreeGood) {
              this.selectedItemUnits[i].taxAmount = Math.floor(((item.adj_price * item.quantity) - item.discount) * item.tax_rate / 100)
            }
            if(item.taxRate != undefined && item.taxRate > 0 && !item.isFreeGood) {
                this.selectedItemUnits[i].taxAmount = Math.floor(((item.adj_price * item.quantity) - item.discount) * item.taxRate / 100)
            }
            if(item.taxRate != undefined && item.taxRate >= 0 && item.taxName!= "") {
              this.selectedItemUnits[i].tax = this.optionsTax.filter(
                (taxes) => taxes.Name == item.taxName
              );
              this.selectedItemUnits[i].tax = this.selectedItemUnits[i].tax[0];
            }
            if(item.taxRate != undefined && item.taxRate == 0 && item.taxName!= "" && !item.isFreeGood) {
              console.log("793 item")
              this.selectedItemUnits[i].taxAmount = Math.floor(((item.adj_price * item.quantity) - item.discount) * item.taxRate)
            }              
          }
        }
        */
      }

      // total tax
      const totalTax = data.reduce((acc, item) => {
        return acc + item.taxAmount;
      }, 0);

      // TODO: total net

      // TODO: total charges

      // TODO: total return
      // console.log("totalListPrice", totalListPrice);
      // console.log("totalAdjPrice", totalAdjPrice);
      // console.log("totalDiscount", totalDiscount);
      // console.log("totalTax", totalTax);

      this.form.summary_data.total_list_price = totalListPrice;
      this.form.summary_data.total_adj_price = totalAdjPrice;
      this.form.summary_data.total_discount = totalDiscount;
      this.form.summary_data.total_tax = totalTax;

      this.total_line = {
        list_price : totalListPrice,
        adj_price : totalAdjPrice,
        tax : totalTax,
        sales_return: this.form.so_types == "with_so_reference" ? (totalListPrice + totalTax) - totalDiscount : totalAdjPrice + totalTax,
        discount: totalDiscount,
      }
      console.log("cek");
      console.log("data", data)
      console.log("this.selectedItemUnits", this.selectedItemUnits)
      // console.log("this.form", this.form);
      // console.log("this.form.summary_data.total_list_price", this.form.summary_data.total_list_price);
      // console.log("this.form.summary_data.total_adj_price", this.form.summary_data.total_adj_price);
      // console.log("this.form.summary_data.total_tax", this.form.summary_data.total_tax);
    },
    customLabelReason(option) {
      return `${option}`;
    },
    customLabelTaxes(val) {
      return `${val.Name}`;
    },
    toggleShowSkuTable(){
      console.log("toggleShowSkuTable")
      console.log("this.form", this.form)
      if(this.form.so_types == "without_so_reference") {
        if(this.form.customer_data.pickup_from_ship_to == null) {
          this.$vs.notify({
            title: "Warning",
            text: "Pickup From / Customer Ship To is required",
            color: "warning",
          });
          return true;
        } else {
          this.showSkuTable = !this.showSkuTable
        }
      }
    },
    async getTaxes() {
      try {
        const resp = await masterRepository.getTaxes();
        if (resp.code == 200) {
          this.optionsTax = [];
          for (let i = 0; i < resp.data.records.length; i++) {
            this.optionsTax.push(resp.data.records[i]);
          }
        } else {
          this.$vs.notify({
            title: "Error",
            text: "Error while fetching master taxes.",
            color: "danger",
            iconPack: "feather",
            icon: "icon-alert-circle",
          });
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: "Error while fetching master taxes.",
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });
        console.log(error);
      }
    },
    async onSelectedTaxes(idx){
      console.log("idx", idx);
      console.log("selectedItemUnits idx", idx, this.selectedItemUnits[idx]);
      if (this.selectedItemUnits[idx].tax.length > 0 || this.selectedItemUnits[idx].tax[0]) {
        this.selectedItemUnits[idx].tax = this.selectedItemUnits[idx].tax[0];
      }
      const tr = this.selectedItemUnits[idx]
      this.selectedItemUnits[idx].taxName = this.selectedItemUnits[idx].tax.Name;
      this.selectedItemUnits[idx].taxRate = this.selectedItemUnits[idx].tax.Rate;
      this.selectedItemUnits[idx].tax = tr.tax;
      this.selectedItemUnits[idx].GenerateTaxInvoice = tr.tax.GenerateTaxInvoice;
      console.log(tr);

      for (let i = 0; i < this.selectedItemUnits.length; i++) {
        if (this.selectedItemUnits[i].sku_code == tr.sku_code) {
          this.selectedItemUnits[i].taxName = tr.tax.Name;
          this.selectedItemUnits[i].taxRate = tr.tax.Rate;
          this.selectedItemUnits[i].tax = tr.tax;
          this.selectedItemUnits[i].GenerateTaxInvoice = tr.tax.GenerateTaxInvoice;
        }
        if (this.selectedItemUnits[i].tax.length > 0 || this.selectedItemUnits[i].tax[0]) {
          this.selectedItemUnits[i].tax = this.selectedItemUnits[i].tax[0];
          this.selectedItemUnits[i].GenerateTaxInvoice = this.selectedItemUnits[i].tax.GenerateTaxInvoice;
        }
      }
      this.form.return_line_item_data = this.selectedItemUnits;
      console.log("this.selectedItemUnits", this.selectedItemUnits);
      this.calculateSummary(this.selectedItemUnits);
    },
    expandDetail(tr,idx){
      console.log("tr, idx")
      console.log(tr,idx)
      console.log("this.selectedItemUnits", this.selectedItemUnits)
      if( this.form.so_types == 'with_so_reference'){
        console.log("this.selectedItemUnits idx", this.selectedItemUnits[idx])
        console.log("this.selectedItemUnits Before", this.selectedItemUnits[idx].is_expand)
        let ixParent = 0;
        this.selectedItemUnits.forEach((el, ix) => {
          if(!tr.parent) {
            if (((el.sku_code+el.isFreeGood) == (tr.sku_code+tr.isFreeGood)) && el.parent) {
              ixParent = ix;
            }
          }
        });
  
        // if (this.selectedItemUnits.length>0&&this.selectedItemUnits[idx]) {
        if (this.selectedItemUnits.length>0&&this.selectedItemUnits[idx] && this.form.so_types == 'with_so_reference' ) {
          this.selectedItemUnits[idx].is_expand = !this.selectedItemUnits[idx].is_expand
          if(!tr.parent) {
            if (this.selectedItemUnits[idx].is_expand) {
              this.selectedItemUnits[ixParent].rowSpanPlus++
              this.selectedItemUnits[idx].rowSpanPlus++
            } else if(this.selectedItemUnits[idx].rowSpanPlus>0){
              this.selectedItemUnits[ixParent].rowSpanPlus--
              this.selectedItemUnits[idx].rowSpanPlus--
            }
            // }else {
            //   if(this.selectedItemUnits[ixParent].rowSpanPlus > 0){
            //     this.selectedItemUnits[ixParent].rowSpanPlus--
            //     this.selectedItemUnits[idx].rowSpanPlus--
            //   }
            // }
          } else {
            if (this.selectedItemUnits[idx].is_expand) {
              this.selectedItemUnits[idx].rowSpanPlus++
            }else if(this.selectedItemUnits[idx].rowSpanPlus>0){
              this.selectedItemUnits[idx].rowSpanPlus--
            }
          }  
        }
        console.log("this.selectedItemUnits idx", this.selectedItemUnits[idx])
        console.log("is_expand After", this.selectedItemUnits[idx].is_expand)
        console.log("this.selectedItemUnits After", this.selectedItemUnits)
      }
    },
  },
  computed: {
    qty_return() {
      return this.selectedItemUnits.map(selectedItemUnits => selectedItemUnits.quantity)
    },
    adj_price() {
      return this.selectedItemUnits.map(selectedItemUnits => selectedItemUnits.adj_price)
    }
  },
  watch: {
    "form.customer_return_data.tax_id.Rate": {
      handler: function (val) {
        this.calculateSummary(this.selectedItemUnits);
      },
      deep: true,
    },
    qty_return(newValue) {
      // console.log("qty_return")
      // console.log("newValue", newValue)
      console.log("this.selectedItemUnits", this.selectedItemUnits)

      // Start logic
      let exceed = [];
      // console.log("oldVal", oldVal)
      if (this.form.so_types == 'with_so_reference') {
        var skus = [], skusFg = [], msg = "";
        // group by sku code & fg
          // console.log("this.selectedItemUnits", this.selectedItemUnits)
          let groupBySkus = this.selectedItemUnits.reduce((acc, item) => {
          // let nama = (!this.form.isEdit && this.form.isDetail == 0) ? item.sku_code + item.isFreeGood : item.sku_code;
          console.log("item", item)

          let nama = (!this.form.isEdit && this.form.isDetail == 0) ? 
          item.sku_code + item.isFreeGood : (item.info != null ? item.sku_code + item.info.is_free_good  : item.sku_code );

          console.log("nama", nama)

          if (!acc[nama]) {
            acc[nama] = [];
            skus.push(item.sku_code);
            skusFg.push(nama);
          }
          acc[nama].push(item);
          item.qty_general_return = item.quantity * item.amount_uom
          return acc;
        }, {});

        let qtyGeneralInvBySKUFG = this.selectedItemUnits.reduce((acc, item) => {
          // let nama = (!this.form.isEdit && this.form.isDetail == 0) ? item.sku_code + item.isFreeGood : item.sku_code;

          let nama = (!this.form.isEdit && this.form.isDetail == 0) ? 
          item.sku_code + item.isFreeGood : (item.info != null ? item.sku_code + item.info.is_free_good  : item.sku_code );

          if (!acc[nama]) {
            acc[nama] = 0;
          }
          acc[nama] += item.qty_general_invoice;
          return acc;
        }, {});

        let qtyGeneralReturnBySKUFG = this.selectedItemUnits.reduce((acc, item) => {
          // let nama = (!this.form.isEdit && this.form.isDetail == 0) ? item.sku_code + item.isFreeGood : item.sku_code;

          let nama = (!this.form.isEdit && this.form.isDetail == 0) ? 
          item.sku_code + item.isFreeGood : (item.info != null ? item.sku_code + item.info.is_free_good  : item.sku_code );

          if (!acc[nama]) {
            acc[nama] = 0;
          }
          acc[nama] += item.qty_general_return;
          return acc;
        }, {});

        let qtyRemainBySKUFG = this.selectedItemUnits.reduce((acc, item) => {
          // let nama = (!this.form.isEdit && this.form.isDetail == 0) ? item.sku_code + item.isFreeGood : item.sku_code;
          let nama = (!this.form.isEdit && this.form.isDetail == 0) ? 
          item.sku_code + item.isFreeGood : (item.info != null ? item.sku_code + item.info.is_free_good  : item.sku_code );

          if (!acc[nama]) {
            acc[nama] = 0;
          }
          if(item.parent){
            acc[nama] += item.total_qty_general_invoice - item.total_qty_general_used;
          }
          return acc;
        }, {});

        console.log("groupBySkus", groupBySkus)
        console.log("qtyGeneralInvBySKUFG", qtyGeneralInvBySKUFG)
        console.log("qtyGeneralReturnBySKUFG", qtyGeneralReturnBySKUFG)
        console.log("qtyRemainBySKUFG", qtyRemainBySKUFG)
        console.log("skusFg", skusFg)
        // console.log("skus", skus)
        // console.log("this.return_type_str", this.return_type_str)

        if (this.return_type_str == '1') {
          this.selectedItemUnits.forEach((sut, i) => {
            this.selectedItemUnits[i].quantity = this.selectedItemUnits[i].qty_invoice;
            this.selectedItemUnits[i].qty_general_return = this.selectedItemUnits[i].qty_general_invoice;
            
            // Ini yang Allow Return False ga ditampilkan
            // if (sut.info.allow_return) {
            //   this.selectedItemUnits[i].quantity = this.selectedItemUnits[i].qty_invoice;
            //   this.selectedItemUnits[i].qty_general_return = this.selectedItemUnits[i].qty_general_invoice;
            // } else {
            //   this.selectedItemUnits[i].quantity = 0;
            //   this.selectedItemUnits[i].qty_general_return = 0;
            // }
          });
          
          // set total Qty
          skusFg.forEach(el => {
            this.selectedItemUnits.forEach((siu, i) => {
              // let nama = (!this.form.isEdit && this.form.isDetail == 0) ? siu.sku_code + siu.isFreeGood : siu.sku_code;
              let nama = (!this.form.isEdit && this.form.isDetail == 0) ? 
              siu.sku_code + siu.isFreeGood : 
                ( this.form.so_types == "with_so_reference" ? 
                (siu.info != null ? siu.sku_code + siu.info.isFreeGood  : siu.sku_code ) : 
                siu.sku_code );

              if (el == nama) {
                this.selectedItemUnits[i].total_qty_general_return = qtyGeneralReturnBySKUFG[el];
              }
            });
          });

          this.calculateSummary(this.selectedItemUnits);            
        }

        let skusExceed = {};
        if (this.return_type_str == '0'){
          skusFg.forEach(el => {
            this.selectedItemUnits.forEach((siu, n) => {
              // let nama = (!this.form.isEdit && this.form.isDetail == 0) ? siu.sku_code + siu.isFreeGood : siu.sku_code;
              let nama = (!this.form.isEdit && this.form.isDetail == 0) ? 
              siu.sku_code + siu.isFreeGood : 
                ( this.form.so_types == "with_so_reference" ? 
                (siu.info != null ? siu.sku_code + siu.info.is_free_good  : siu.sku_code ) : 
                siu.sku_code );
                
              
              if (el == nama) {
                console.log("el == nama, n", (el == nama), n)
                console.log("el , nama, n", el , nama, n)
              
                siu.total_qty_general_return = qtyGeneralReturnBySKUFG[el];
                this.selectedItemUnits[n].total_qty_general_return = qtyGeneralReturnBySKUFG[el];
              }
              if (qtyGeneralReturnBySKUFG[el] > qtyRemainBySKUFG[el] && this.form.isDetail != 1) {
                if(el == (nama) && !skusExceed[siu.sku_code]){
                  skusExceed[siu.sku_code] = siu.sku_code;
                  exceed.push(siu.sku_code);
                  siu.quantity = 0;
                  siu.qty_general_return = 0;
                  siu.total_qty_general_return = 0;
                  this.selectedItemUnits[n].total_qty_general_return = 0;
                }
              } else {
                if(el == nama){
                  siu.qty_general_return = siu.quantity * siu.amount_uom;
                  
                  // Ini yang Allow Return False ga ditampilkan
                  // if (siu.info.allow_return) {
                  //   siu.qty_general_return = siu.quantity * siu.amount_uom;
                  // } else {
                  //   siu.quantity = 0;
                  //   siu.qty_general_return = 0;
                  // }
                }
              }
            });
            //
          });
          this.calculateSummary(this.selectedItemUnits);            
        }

        // console.log("skusExceed", skusExceed)
        // console.log("exceed", exceed)
      }
      console.log("exceed", exceed)

      if (exceed.length > 0 && this.form.isDetail != 1) {
        exceed.forEach(el => {
          msg += el + "<br>"
          this.selectedItemUnits.forEach((siu, n) => {
            // reset quantity disini
            if(this.selectedItemUnits[n].sku_code == el){
              this.selectedItemUnits[n].quantity = 0;
            }
          });
        });
        msg = "Quantity retur cannot greater than Invoice Remaining Quantity for SKU : <br>" + msg
        this.$vs.notify({
          title: "Warning",
          text: msg,
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });

        console.log("this.selectedItemUnits reset qty", this.selectedItemUnits)
        this.form.return_line_item_data = this.selectedItemUnits;
        // console.log("this.form.return_line_item_data", this.form.return_line_item_data)
        // console.log("this.selectedItemUnits", this.selectedItemUnits)
        return
      }
      this.form.return_line_item_data = this.selectedItemUnits;
      console.log("this.selectedItemUnits after", this.selectedItemUnits)
      // calculate summary
      this.calculateSummary(this.selectedItemUnits);
    },
    adj_price(newValue) {
      console.log("newValue", newValue)
      this.calculateSummary(this.selectedItemUnits);
    },
      /*
    selectedItemUnits: {
      handler: function (val) {
        let exceed = [];
        console.log("val", val)
        // console.log("oldVal", oldVal)
        if (this.form.so_types == 'with_so_reference') {
          var skus = [], skusFg = [], msg = "";
          if (this.return_type_str == '1') {
            this.selectedItemUnits.forEach((_, i) => {
              this.selectedItemUnits[i].quantity = this.selectedItemUnits[i].qty_invoice;
              this.selectedItemUnits[i].qty_general_return = this.selectedItemUnits[i].qty_general_invoice;
            });
            console.log("call calculateSummary")
            this.calculateSummary(val);            
          }

          // group by sku code & fg
          let groupBySkus = this.selectedItemUnits.reduce((acc, item) => {
            let nama = (!this.form.isEdit && this.form.isDetail == 0) ? item.sku_code + item.isFreeGood : item.sku_code;
            if (!acc[nama]) {
              acc[nama] = [];
              skus.push(item.sku_code);
              skusFg.push(nama);
            }
            acc[nama].push(item);
            item.qty_general_return = item.quantity * item.amount_uom
            return acc;
          }, {});

          let qtyGeneralInvBySKUFG = this.selectedItemUnits.reduce((acc, item) => {
            let nama = (!this.form.isEdit && this.form.isDetail == 0) ? item.sku_code + item.isFreeGood : item.sku_code;
            if (!acc[nama]) {
              acc[nama] = 0;
            }
            acc[nama] += item.qty_general_invoice;
            return acc;
          }, {});

          let qtyGeneralReturnBySKUFG = this.selectedItemUnits.reduce((acc, item) => {
            let nama = (!this.form.isEdit && this.form.isDetail == 0) ? item.sku_code + item.isFreeGood : item.sku_code;
            if (!acc[nama]) {
              acc[nama] = 0;
            }
            acc[nama] += item.qty_general_return;
            return acc;
          }, {});

          let qtyRemainBySKUFG = this.selectedItemUnits.reduce((acc, item) => {
            let nama = (!this.form.isEdit && this.form.isDetail == 0) ? item.sku_code + item.isFreeGood : item.sku_code;
            if (!acc[nama]) {
              acc[nama] = 0;
            }
            if(item.parent){
              acc[nama] += item.total_qty_general_invoice - item.total_qty_general_used;
            }
            return acc;
          }, {});

          // console.log("groupBySkus", groupBySkus)
          // console.log("qtyGeneralInvBySKUFG", qtyGeneralInvBySKUFG)
          // console.log("qtyGeneralReturnBySKUFG", qtyGeneralReturnBySKUFG)
          // console.log("qtyRemainBySKUFG", qtyRemainBySKUFG)
          console.log("skusFg", skusFg)
          // console.log("skus", skus)
          console.log("this.return_type_str", this.return_type_str)

          let skusExceed = {};
          if (this.return_type_str == '0'){
            skusFg.forEach(el => {
              //
              // this.selectedItemUnits.forEach((siu, n) => {
              //   console.log("this.selectedItemUnits[n]", this.selectedItemUnits[n])
              //   let nama = (!this.form.isEdit && this.form.isDetail == 0) ? siu.sku_code + siu.isFreeGood : siu.sku_code;
              //   if (qtyGeneralReturnBySKUFG[el] > qtyRemainBySKUFG[el]) {
              //     if(el == (nama) && !skusExceed[siu.sku_code]){
              //       skusExceed[siu.sku_code] = siu.sku_code;
              //       exceed.push(siu.sku_code);
              //       siu.quantity = 0;
              //       siu.qty_general_return = 0;
              //     }
              //     siu.total_qty_general_return = 0;
              //   } else {
              //     // console.log("masuk sini to 1146")
              //     if(el == (nama) && siu.parent){
              //       // console.log("masuk sini to 1148", siu)
              //       // console.log("el", el)
              //       // console.log("qtyGeneralReturnBySKUFG[el]", qtyGeneralReturnBySKUFG[el])
              //       siu.qty_general_return = qtyGeneralReturnBySKUFG[el];
              //       siu.total_qty_general_return = qtyGeneralReturnBySKUFG[el];
              //       this.selectedItemUnits[n].total_qty_general_return = qtyGeneralReturnBySKUFG[el];
              //     }
              //     console.log("Langsung rene?")
              //     console.log("n", n)
              //     this.selectedItemUnits[n].total_qty_general_return = qtyGeneralReturnBySKUFG[el];
              //   }
              // });
              //
            });
          }

          // console.log("skusExceed", skusExceed)
          // console.log("exceed", exceed)
        }
        // console.log("exceed", exceed)

        if (exceed.length > 0) {
          exceed.forEach(el => {
            msg += el + "<br>"
          });
          msg = "Quantity retur cannot greater than Invoice Remaining Quantity for SKU : <br>" + msg
          this.$vs.notify({
            title: "Warning",
            text: msg,
            color: "danger",
            iconPack: "feather",
            icon: "icon-alert-circle",
          });
          this.form.return_line_item_data = this.selectedItemUnits;
          // console.log("this.form.return_line_item_data", this.form.return_line_item_data)
          // console.log("this.selectedItemUnits", this.selectedItemUnits)
          return
        }
        this.form.return_line_item_data = this.selectedItemUnits;
        // calculate summary
        this.calculateSummary(val);
      },
      deep: true,
    },
    */
    "form.customer_invoice_data.invoice_lines": {
      handler: function (val) {
        
        if (val != null) {
          console.log("invoice Sku_hu", this.form.customer_invoice_data.sku_hu)

          this.selectedItemUnits = [];
          this.selectedItemUnitsInv = [];
          let newDataDto, allDtos = [], regDtos = [], fgDtos = [];

          // let srPrices =  val.reduce((acc, item) => {
          //   if (!acc[item.SkuCode] && item.SrPrice > 0) {
          //     acc[item.SkuCode] = item.SrPrice;
          //   }
          //   if (item.SrPrice == 0 && acc[item.SkuCode] > 0) {
          //     item.SrPrice = acc[item.SkuCode]
          //   }
          //   return acc;
          // }, {});

          console.log("val", val)
          val.forEach((item) => {
            let sku_code = item.SkuCode
            let this_hu = this.form.customer_invoice_data.sku_hu[sku_code];
            item.ItemID = this_hu[0].item_id;
            if (item.ItemUnitAmountUom == 0) {
              this_hu.forEach((el) => {
                if (el.unit == item.Unit) {
                  item.ItemUnitAmountUom = el.amount_uom;
                  item.ItemID = el.item_id;
                }
              });
            }
          });

          // console.log("total_amt_uom_order", total_amt_uom_order)
          // console.log("total_value_freegood", total_value_freegood)

          // disc_fg = parseFloat( total_value_freegood / total_amt_uom_order );
          // console.log("disc_fg", disc_fg)

          val.forEach((item) => {
            console.log("item", item)
            item.disc_fg = 0;
            newDataDto = this.convertDTO(item);
            // console.log("newDataDto Before", newDataDto)
            if (this.return_type_str == "1") {
              newDataDto.qty_general_return = newDataDto.qty_general_invoice
            }
            // console.log("newDataDto After", newDataDto)
            allDtos.push(newDataDto);

            if(newDataDto.is_free_good){
              fgDtos.push(newDataDto);
            } else {
              regDtos.push(newDataDto);
            }
          });

          // Ini cek parent freeGood
          console.log("fgDtos", fgDtos)
          console.log("regDtos", regDtos)

          fgDtos.forEach(dto => {
            let total_amt_uom_order = dto.qty_general_return;
            let total_value_freegood = parseFloat( (dto.qty_general_return / dto.amount_uom) * dto.price );
            let disc_fg = 0;

            if (dto.is_free_good && dto.info.related_item_id) {
              console.log("dto.info.related_item_id", dto.info.related_item_id)
              console.log("dto", dto)
              console.log("dto.qty_general_return", dto.qty_general_return)
              console.log("dto quantity", dto.quantity)
              console.log("dto sr_price", dto.sr_price)
              console.log("val FG", (dto.qty_general_return * dto.sr_price))

              // total_value_freegood = parseFloat( dto.qty_general_return * dto.sr_price );
              // total_value_freegood = parseFloat( (dto.qty_general_return / dto.amount_uom) * dto.price );
              // total_amt_uom_order += dto.qty_general_return
              
              dto.info.related_item_id.forEach(itemRelated => {
                console.log("itemRelated", itemRelated)                
                regDtos.forEach(dtoParent => {
                  if (dtoParent.item_id == itemRelated && dto.info.allow_return){
                    console.log("dtoParent", dtoParent)
                    // ini set allow_return based on FG for all related parent (in case promo mix SKU dan Fg nya allow return false)
                    dtoParent.info.allow_return = dto.info.allow_return;

                    total_amt_uom_order += dtoParent.qty_general_return
                  }
                });
                
              });
              
              console.log("total_value_freegood", total_value_freegood)
              console.log("total_amt_uom_order", total_amt_uom_order)
              disc_fg = parseFloat( total_value_freegood / total_amt_uom_order );
              console.log("disc_fg", disc_fg)
              
              dto.info.related_item_id.forEach(itemRelated => {

                regDtos.forEach(dtoParent => {
                  console.log("dtoParent", dtoParent)
                  if (dtoParent.item_id == itemRelated && dto.info.allow_return){
                    // ini set discount Fg
                    if(dtoParent.info.disc_fg == 0){
                      dtoParent.info.disc_fg = disc_fg;
                    } else {
                      dtoParent.info.disc_fg += disc_fg;
                    }
                  }
                });
                
              });
            }

            console.log("disc_fg", disc_fg)
            dto.info.disc_fg = disc_fg
          });
          // group by sku code
          console.log("allDtos", allDtos)
          let groupBySkuCode = allDtos.reduce((acc, item) => {
            if (!acc[item.sku_code+item.isFreeGood]) {
              acc[item.sku_code+item.isFreeGood] = [];
            }
            acc[item.sku_code+item.isFreeGood].push(item);
            return acc;
          }, {});

          // make first line on each sku code as parent
          groupBySkuCode = Object.values(groupBySkuCode).map((item) => {
            item[0].parent = true;
            return item;
          });
          
          // add unit names on item.parent each sku code
          groupBySkuCode.forEach((item) => {
            let unit_names = item.map((item) => item.unit_name);
            // let len = groupBySkuCode[item.sku_code].length
            item.forEach((item) => {
              if (item.parent) {
                item.units = unit_names;
                item.unit_names = unit_names.join(", ");
              }
              // item.lilUom = groupBySkuCode[item.sku_code][len-1].unit_name
            });
          });
          
          // push to selected item units
          // groupBySkuCode.forEach((item) => {
          // });
          
          console.log("groupBySkuCode", groupBySkuCode)
          groupBySkuCode.forEach((item, igroup) => {
            let detail_hu = {}, idx_hu = {};
            let sku_code = item[0].sku_code
            let this_hu = this.form.customer_invoice_data.sku_hu[sku_code];
            
            console.log("this_hu", this_hu)
            console.log("igroup", igroup)
            console.log("item", item)
            console.log("groupBySkuCode[igroup]", groupBySkuCode[igroup])
            
            item.forEach((dt, ix) => {
              detail_hu[dt.unit_name] = dt.unit_name
              idx_hu[dt.unit_name] = ix
            });
            console.log("detail_hu", detail_hu)
            console.log("idx_hu", idx_hu)

            // Ini ngetotal qty remaining
            let total_qty_general_invoice = 0
            let total_qty_general_return = 0
            let total_qty_general_used = 0
            item.forEach((item) => {
              total_qty_general_invoice += item.qty_general_invoice
              total_qty_general_return += item.qty_general_return
              total_qty_general_used += item.qty_general_used
            });
            
            item.forEach((item) => {
              item.total_qty_general_invoice = total_qty_general_invoice
              item.total_qty_general_return = total_qty_general_return
              item.total_qty_general_used = total_qty_general_used
            });

            // Try to push all HU, if invLine tidak mengandung HU ini, maka push kosongan.

            let replaceItems = []
            let replaceHus = []
            this_hu.forEach(el => {
              replaceHus.push(el.unit);
            });

            this_hu.forEach((el, i) => {
              if(detail_hu[el.unit] != undefined && i == 0){

                item[ idx_hu[el.unit] ].units = replaceHus
                item[ idx_hu[el.unit] ].unit_names = replaceHus.join(", ");
                item[ idx_hu[el.unit] ].parent = true;
                replaceItems.push( item[ idx_hu[el.unit] ] )

              } else if(detail_hu[el.unit] != undefined && i != 0){
                item[ idx_hu[el.unit] ].parent = false;
                replaceItems.push( item[ idx_hu[el.unit] ] )

              } else {
                let tempItem = { ...item[0] };

                tempItem.invoice_line_id = 0;
                tempItem.unit_name = el.unit
                tempItem.lilUom = this_hu[ this_hu.length-1 ].unit

                tempItem.amount_uom = el.amount_uom;
                tempItem.qty_general_invoice = 0;
                tempItem.qty_general_return = 0;
                tempItem.qty_general_used = 0;
                tempItem.total_qty_general_return = 0;
                tempItem.total_qty_general_used = total_qty_general_used;
                // tempItem.total_qty_general_invoice = 0;
                
                tempItem.adj_price = 0;
                tempItem.taxAmount = 0;
                tempItem.discount = 0;
                tempItem.inv_discount = 0;

                tempItem.qty_invoice= 0;
                tempItem.quantity= 0;
                tempItem.so_price= 0;
                tempItem.price= 0;
                tempItem.sr_price= parseFloat( (item[0].sr_price / item[0].amount_uom) * el.amount_uom );
                tempItem.subtotal= 0;
                tempItem.sr_subtotal= 0;

                if (i == 0) {
                  tempItem.units = replaceHus
                  tempItem.unit_names = replaceHus.join(", ");
                  tempItem.parent = true;
                } else {
                  tempItem.parent = false;
                }

                console.log("tempItem", tempItem)
                console.log("tempItem.sr_price", tempItem.sr_price)
                console.log("item[0].sr_price", item[0].sr_price)
                console.log("item[0].amount_uom", item[0].amount_uom)
                console.log("el.amount_uom", el.amount_uom)
                
                replaceItems.push(
                  tempItem
                  // { index:"ini item kosongan" }
                );
              }
            });
            console.log("item", item)
            console.log("replaceItems", replaceItems)

            groupBySkuCode[igroup] = []; groupBySkuCode[igroup] = replaceItems;
            console.log("item after", item)
            console.log("item after", item)
          });

          console.log("groupBySkuCode after", groupBySkuCode)
          // push to selected item units
          groupBySkuCode.forEach((itemGroup) => {
            // let lilUom = item[item.length - 1].unit_name

            let lilUom = this.form.customer_invoice_data.sku_hu[ itemGroup[0].sku_code ][ this.form.customer_invoice_data.sku_hu[ itemGroup[0].sku_code ].length-1 ].unit

            console.log("item", itemGroup)
            console.log("this.form.customer_invoice_data.sku_hu[ itemGroup[0].sku_code ]", this.form.customer_invoice_data.sku_hu[ itemGroup[0].sku_code ])

            itemGroup.forEach((item) => {
              console.log("item 1785", item)
              item.lilUom = lilUom;
              // Masukkan ke if ini kalau allow_return false tdk ditampilkan
              // if (item.info.allow_return) {
              // }
              if (this.return_type_str == "1") {
                this.selectedItemUnits.push(item);
              } else if (this.return_type_str == "0" && !item.isFreeGood) {
                this.selectedItemUnits.push(item);
              }
              this.selectedItemUnitsInv.push(item);
            });
          });

          this.form.return_line_item_data = this.selectedItemUnits;
        }
        console.log("this.selectedItemUnits", this.selectedItemUnits)
        // console.log("this.selectedItemUnitsInv", this.selectedItemUnitsInv)
      },
      deep: true,
    },
    return_type_str: {
      handler: function (val) {

        console.log("this.form", this.form)
        console.log("this.selectedItemUnits", this.selectedItemUnits)
        console.log("this.selectedItemUnitsInv", this.selectedItemUnitsInv)

        if( (!this.form.isEdit && this.form.isDetail == 0) ) {
          if (this.selectedItemUnitsInv.length > 0) {
            this.selectedItemUnitsInv.forEach(el => {
              el.quantity = el.qty_invoice;
            });
            if (val == "1") {
              // Kondisi 1 full return [Reguler + Free Good] | Qty sama dengan invoice
              this.selectedItemUnits = this.selectedItemUnitsInv;

              // Pakai ini kalau item allow_return false tdk ditampilkan
              // Di filter yang allow return True
              // this.selectedItemUnits = this.selectedItemUnitsInv.filter(
              //   (item) => item.info.allow_return == true
              // );
            } else {
              // Kondisi 0 partial return [Reguler Only]
              this.selectedItemUnits = this.selectedItemUnitsInv.filter(
                (item) => item.isFreeGood == false
                // Pakai ini kalau item allow_return false tdk ditampilkan
                // Di filter yang allow return True
                // (item) => (item.isFreeGood == false && item.info.allow_return == true)
              );
            }
            // calculate summary
            this.calculateSummary(this.selectedItemUnits);
          }
          this.calculateSummary(this.selectedItemUnits);
        } else {
          // ini kondisi edit. Lookup invoice nya lagi

          console.log("invoices Sku_hu", this.form.sku_hu)

          let invoice_line_data = this.form.invoice_line_data

          this.selectedItemUnits = [];
          this.selectedItemUnitsInv = [];
          let newDataDto, allDtos = [];

          // let srPrices =  invoice_line_data.reduce((acc, item) => {
          //   if (!acc[item.SkuCode] && item.SrPrice > 0) {
          //     acc[item.SkuCode] = item.SrPrice;
          //   }
          //   if (item.SrPrice == 0 && acc[item.SkuCode] > 0) {
          //     item.SrPrice = acc[item.SkuCode]
          //   }
          //   return acc;
          // }, {});

          let total_amt_uom_order = 0;
          let total_value_freegood = 0;
          let disc_fg = 0;

          invoice_line_data.forEach((item) => {
            console.log("item", item)
            if (item.Information != null) {
              if (!item.Information.is_free_item) {
                total_amt_uom_order += (item.Qty * item.ItemUnitAmountUom)
              } else {
                total_value_freegood += (item.Qty * item.SrPrice)
              }
            }
          });

          console.log("total_amt_uom_order", total_amt_uom_order)
          console.log("total_value_freegood", total_value_freegood)

          disc_fg = parseFloat( total_value_freegood / total_amt_uom_order );
          console.log("disc_fg", disc_fg)

          invoice_line_data.forEach((item) => {
            console.log("item", item)
            item.disc_fg = disc_fg
            newDataDto = this.convertDTO(item);
            // console.log("newDataDto Before", newDataDto)
            if (this.return_type_str == "1") {
              newDataDto.qty_general_return = newDataDto.qty_general_invoice
            }
            // console.log("newDataDto After", newDataDto)
            allDtos.push(newDataDto);
          });
          
          // group by sku code
          let groupBySkuCode = allDtos.reduce((acc, item) => {
            if (!acc[item.sku_code+item.isFreeGood]) {
              acc[item.sku_code+item.isFreeGood] = [];
            }
            acc[item.sku_code+item.isFreeGood].push(item);
            return acc;
          }, {});

          // make first line on each sku code as parent
          groupBySkuCode = Object.values(groupBySkuCode).map((item) => {
            item[0].parent = true;
            return item;
          });
          
          // add unit names on item.parent each sku code
          groupBySkuCode.forEach((item) => {
            let unit_names = item.map((item) => item.unit_name);
            // let len = groupBySkuCode[item.sku_code].length
            item.forEach((item) => {
              if (item.parent) {
                item.units = unit_names;
                item.unit_names = unit_names.join(", ");
              }
              // item.lilUom = groupBySkuCode[item.sku_code][len-1].unit_name
            });
          });
          
          // push to selected item units
          groupBySkuCode.forEach((item) => {
            let total_qty_general_invoice = 0
            let total_qty_general_return = 0
            let total_qty_general_used = 0
            item.forEach((item) => {
              total_qty_general_invoice += item.qty_general_invoice
              total_qty_general_return += item.qty_general_return
              total_qty_general_used += item.qty_general_used
            });
            
            item.forEach((item) => {
              item.total_qty_general_invoice = total_qty_general_invoice
              item.total_qty_general_return = total_qty_general_return
              item.total_qty_general_used = total_qty_general_used
            });
          });
          
          console.log("groupBySkuCode", groupBySkuCode)
          groupBySkuCode.forEach((item, igroup) => {
            let detail_hu = {}, idx_hu = {};
            let sku_code = item[0].sku_code
            console.log("igroup", igroup)
            console.log("item", item)
            console.log("groupBySkuCode[igroup]", groupBySkuCode[igroup])
            item.forEach((dt, ix) => {
              detail_hu[dt.unit_name] = dt.unit_name
              idx_hu[dt.unit_name] = ix
            });
            console.log("detail_hu", detail_hu)
            console.log("idx_hu", idx_hu)

            // Try to push all HU, if invLine tidak mengandung HU ini, maka push kosongan.
            let this_hu = this.form.sku_hu[sku_code];
            console.log("this_hu", this_hu)

            let replaceItems = []
            let replaceHus = []
            this_hu.forEach(el => {
              replaceHus.push(el.unit);
            });

            this_hu.forEach((el, i) => {
              if(detail_hu[el.unit] != undefined && i == 0){

                item[ idx_hu[el.unit] ].units = replaceHus
                item[ idx_hu[el.unit] ].unit_names = replaceHus.join(", ");
                item[ idx_hu[el.unit] ].parent = true;
                replaceItems.push( item[ idx_hu[el.unit] ] )

              } else if(detail_hu[el.unit] != undefined && i != 0){
                item[ idx_hu[el.unit] ].parent = false;
                replaceItems.push( item[ idx_hu[el.unit] ] )

              } else {
                let tempItem = { ...item[0] };

                tempItem.invoice_line_id = 0;
                tempItem.unit_name = el.unit
                tempItem.lilUom = this_hu[ this_hu.length-1 ].unit

                tempItem.amount_uom = el.amount_uom;
                tempItem.qty_general_invoice = 0;
                tempItem.qty_general_return = 0;
                tempItem.qty_general_used = 0;
                tempItem.total_qty_general_return = 0;
                tempItem.total_qty_general_used = 0;
                // tempItem.total_qty_general_invoice = 0;
                
                tempItem.adj_price = 0;
                tempItem.taxAmount = 0;
                tempItem.discount = 0;
                tempItem.inv_discount = 0;

                tempItem.qty_invoice= 0;
                tempItem.quantity= 0;
                tempItem.so_price= 0;
                tempItem.price= 0;
                tempItem.sr_price= parseFloat( (item[0].sr_price / item[0].amount_uom) * el.amount_uom );
                tempItem.subtotal= 0;
                tempItem.sr_subtotal= 0;

                if (i == 0) {
                  tempItem.units = replaceHus
                  tempItem.unit_names = replaceHus.join(", ");
                  tempItem.parent = true;
                } else {
                  tempItem.parent = false;
                }

                console.log("tempItem", tempItem)
                console.log("item[0]", item[0])
                
                replaceItems.push(
                  tempItem
                  // { index:"ini item kosongan" }
                );
              }
            });
            console.log("item", item)
            console.log("replaceItems", replaceItems)

            groupBySkuCode[igroup] = []; groupBySkuCode[igroup] = replaceItems;
            console.log("item after", item)
            console.log("item after", item)
          });

            console.log("groupBySkuCode after", groupBySkuCode)
          // push to selected item units
          groupBySkuCode.forEach((item) => {
            // let lilUom = item[item.length - 1].unit_name

            let lilUom = this.form.sku_hu[ item[0].sku_code ][ this.form.sku_hu[ item[0].sku_code ].length-1 ].unit

            console.log("item", item)
            console.log("this.form.sku_hu[ item[0].sku_code ]", this.form.sku_hu[ item[0].sku_code ])

            item.forEach((item) => {
              if (this.return_type_str == "1") {
                this.selectedItemUnits.push(item);
              } else if (this.return_type_str == "0" && !item.isFreeGood) {
                this.selectedItemUnits.push(item);
              }
              item.lilUom = lilUom;
              this.selectedItemUnitsInv.push(item);
            });
          });

          this.form.return_line_item_data = this.selectedItemUnits;

          // Batas
        }
      },
      deep: true,
    },
  },
};
</script>
